/*
 * The textbook's vocabulary: every term in its glossary, with the chapter and
 * section it belongs to, and a definition.
 *
 * GENERATED by scripts/build-vocabulary.mjs from assets/vocab-terms.txt and
 * assets/vocab-definitions.txt — do not edit by hand. Edit those.
 *
 * The terms are the book's. The definitions are NOT: the glossary's prose
 * belongs to the publisher, so every definition here was written for this app
 * instead, in plain words, for this course.
 */

export interface VocabTerm {
  term: string;
  chapter: number;
  /** "6.4" — chapter and section, as the glossary prints it. */
  section: string;
  /** Written for this app, not copied from the textbook. */
  definition: string;
}

export const VOCABULARY: VocabTerm[] = [
  {
    "term": "atomic theory",
    "chapter": 1,
    "section": "1.2",
    "definition": "The idea that all matter is built from atoms, tiny particles that keep their identity through chemical change. Nearly everything else in the course is a consequence of it."
  },
  {
    "term": "Celsius (°C) scale",
    "chapter": 1,
    "section": "1.6",
    "definition": "The everyday metric temperature scale: water freezes at 0 °C and boils at 100 °C. K = °C + 273.15."
  },
  {
    "term": "chemical change",
    "chapter": 1,
    "section": "1.4",
    "definition": "A change that turns one substance into a different one, because bonds break and form. Iron rusting, paper burning."
  },
  {
    "term": "chemical property",
    "chapter": 1,
    "section": "1.4",
    "definition": "Something a substance does only by reacting — flammable, corrodes in acid, inert in water. You cannot observe it without changing the substance."
  },
  {
    "term": "chemistry",
    "chapter": 1,
    "section": "1.1",
    "definition": "The study of what matter is made of, what it does, and why."
  },
  {
    "term": "composition",
    "chapter": 1,
    "section": "1.3",
    "definition": "What a sample is made of and in what proportion: which elements, how much of each."
  },
  {
    "term": "compound",
    "chapter": 1,
    "section": "1.3",
    "definition": "A pure substance of two or more elements chemically bonded in a fixed ratio. Water is always H₂O."
  },
  {
    "term": "conversion factor",
    "chapter": 1,
    "section": "1.8",
    "definition": "A fraction equal to 1, built from an equality such as (1 in / 2.54 cm), used to change units without changing the quantity."
  },
  {
    "term": "crystalline",
    "chapter": 1,
    "section": "1.3",
    "definition": "Having particles packed in an orderly repeating pattern. Table salt and quartz are crystalline; glass is not."
  },
  {
    "term": "decanting",
    "chapter": 1,
    "section": "1.3",
    "definition": "Separating a liquid from a settled solid by pouring the liquid off and leaving the solid behind."
  },
  {
    "term": "density (d)",
    "chapter": 1,
    "section": "1.6",
    "definition": "Mass per unit volume, d = m/V, usually g/mL for liquids and g/cm³ for solids. Intensive, so it helps identify a substance."
  },
  {
    "term": "derived unit",
    "chapter": 1,
    "section": "1.6",
    "definition": "A unit built from others by multiplying or dividing — m/s, g/mL, cm³ — rather than a base unit like the metre."
  },
  {
    "term": "dimensional analysis",
    "chapter": 1,
    "section": "1.8",
    "definition": "Solving by tracking units: multiply by conversion factors so the unwanted units cancel and the wanted one is left. The most useful habit in this course."
  },
  {
    "term": "distillation",
    "chapter": 1,
    "section": "1.3",
    "definition": "Separating a mixture by boiling it and condensing the vapour, which works because the components boil at different temperatures."
  },
  {
    "term": "element",
    "chapter": 1,
    "section": "1.3",
    "definition": "A substance chemistry cannot break down further — one kind of atom. The boxes on the periodic table."
  },
  {
    "term": "English system",
    "chapter": 1,
    "section": "1.6",
    "definition": "The inches, pounds and gallons system still used in the United States, as opposed to the metric system."
  },
  {
    "term": "exact numbers",
    "chapter": 1,
    "section": "1.7",
    "definition": "Numbers with no uncertainty: counted objects and defined equalities, like 12 in 1 ft. They never limit the significant figures in an answer."
  },
  {
    "term": "experiment",
    "chapter": 1,
    "section": "1.2",
    "definition": "A deliberate test, set up so that its result is able to disagree with the idea being tested."
  },
  {
    "term": "extensive property",
    "chapter": 1,
    "section": "1.6",
    "definition": "A property that depends on how much you have — mass, volume, total energy. Twice the sample, twice the value."
  },
  {
    "term": "Fahrenheit (°F) scale",
    "chapter": 1,
    "section": "1.6",
    "definition": "The US temperature scale: water freezes at 32 °F and boils at 212 °F. °C = (°F − 32)/1.8."
  },
  {
    "term": "filtration",
    "chapter": 1,
    "section": "1.3",
    "definition": "Separating an insoluble solid from a liquid by pouring the mixture through filter paper."
  },
  {
    "term": "gas",
    "chapter": 1,
    "section": "1.3",
    "definition": "The state with neither fixed shape nor fixed volume: particles far apart and moving freely, so a gas fills its container and compresses easily."
  },
  {
    "term": "heterogeneous mixture",
    "chapter": 1,
    "section": "1.3",
    "definition": "A mixture whose composition varies from place to place, so the parts are visible — sand in water, oil and vinegar."
  },
  {
    "term": "homogeneous mixture",
    "chapter": 1,
    "section": "1.3",
    "definition": "A mixture uniform throughout, so it looks like one substance. Salt water, air, brass. Also called a solution."
  },
  {
    "term": "hypothesis",
    "chapter": 1,
    "section": "1.2",
    "definition": "A tentative explanation, stated so that an experiment could show it to be wrong."
  },
  {
    "term": "intensive property",
    "chapter": 1,
    "section": "1.6",
    "definition": "A property independent of amount — density, temperature, melting point — so it is useful for identifying a substance."
  },
  {
    "term": "International System of Units (SI)",
    "chapter": 1,
    "section": "1.6",
    "definition": "The agreed base units of science — metre, kilogram, second, kelvin, mole, ampere, candela — and everything derived from them."
  },
  {
    "term": "kelvin (K)",
    "chapter": 1,
    "section": "1.6",
    "definition": "The SI unit of temperature. The same size step as a Celsius degree, but counted from absolute zero, so there are no negative kelvins."
  },
  {
    "term": "Kelvin scale",
    "chapter": 1,
    "section": "1.6",
    "definition": "The absolute temperature scale, zero at absolute zero (−273.15 °C). Gas laws only work in kelvins."
  },
  {
    "term": "kilogram (kg)",
    "chapter": 1,
    "section": "1.6",
    "definition": "The SI base unit of mass, about 2.205 lb. Note that the base unit already carries a prefix."
  },
  {
    "term": "kinetic energy",
    "chapter": 1,
    "section": "1.5",
    "definition": "Energy of motion, KE = ½mv². In chemistry it is usually the motion of particles, which is what temperature measures."
  },
  {
    "term": "law",
    "chapter": 1,
    "section": "1.2",
    "definition": "A short statement, often an equation, summarising what always happens. A law says what; a theory says why."
  },
  {
    "term": "law of conservation of energy",
    "chapter": 1,
    "section": "1.5",
    "definition": "Energy is neither created nor destroyed, only moved or converted from one form to another."
  },
  {
    "term": "law of conservation of mass",
    "chapter": 1,
    "section": "1.2",
    "definition": "Matter is neither created nor destroyed in a reaction, so the mass of the products equals the mass of the reactants. This is why equations must balance."
  },
  {
    "term": "liquid",
    "chapter": 1,
    "section": "1.3",
    "definition": "The state with fixed volume but no fixed shape: particles touching but free to slide, so a liquid pours and barely compresses."
  },
  {
    "term": "liter (L)",
    "chapter": 1,
    "section": "1.6",
    "definition": "The common metric unit of volume: 1 L = 1000 mL = 1 dm³."
  },
  {
    "term": "mass",
    "chapter": 1,
    "section": "1.6",
    "definition": "How much matter something contains, in grams or kilograms. Unlike weight, it does not change with gravity."
  },
  {
    "term": "matter",
    "chapter": 1,
    "section": "1.3",
    "definition": "Anything that has mass and takes up space."
  },
  {
    "term": "meter (m)",
    "chapter": 1,
    "section": "1.6",
    "definition": "The SI base unit of length, about 39.37 inches."
  },
  {
    "term": "metric system",
    "chapter": 1,
    "section": "1.6",
    "definition": "The decimal system of units, in which sizes differ by powers of ten, so converting means moving a decimal point."
  },
  {
    "term": "milliliter (mL)",
    "chapter": 1,
    "section": "1.6",
    "definition": "One thousandth of a litre, and exactly 1 cm³. The unit most of your volumes will be in."
  },
  {
    "term": "mixture",
    "chapter": 1,
    "section": "1.3",
    "definition": "Two or more substances physically combined in no fixed ratio, each keeping its own properties and separable without chemistry."
  },
  {
    "term": "molecule",
    "chapter": 1,
    "section": "1.1",
    "definition": "Two or more atoms held together by covalent bonds, acting as one particle: H₂O, O₂, C₆H₁₂O₆."
  },
  {
    "term": "physical change",
    "chapter": 1,
    "section": "1.4",
    "definition": "A change in which the substance stays the same substance and only its form or state changes. Ice melting, sugar dissolving."
  },
  {
    "term": "physical property",
    "chapter": 1,
    "section": "1.4",
    "definition": "Something observable or measurable without changing what the substance is: colour, density, melting point, odour."
  },
  {
    "term": "potential energy",
    "chapter": 1,
    "section": "1.5",
    "definition": "Stored energy, held in position or in chemical bonds, waiting to be released."
  },
  {
    "term": "precision",
    "chapter": 1,
    "section": "1.7",
    "definition": "How closely repeated measurements agree with each other. Not the same as accuracy — a miscalibrated balance is precisely wrong."
  },
  {
    "term": "prefix multipliers",
    "chapter": 1,
    "section": "1.6",
    "definition": "The syllables that scale a metric unit by a power of ten: kilo- 10³, centi- 10⁻², milli- 10⁻³, micro- 10⁻⁶, nano- 10⁻⁹."
  },
  {
    "term": "pure substance",
    "chapter": 1,
    "section": "1.3",
    "definition": "Matter of one fixed composition throughout — a single element or a single compound, not a mixture."
  },
  {
    "term": "random error",
    "chapter": 1,
    "section": "1.7",
    "definition": "Scatter falling on both sides of the true value, from reading and judging. It averages out over many trials and limits precision."
  },
  {
    "term": "scientific law",
    "chapter": 1,
    "section": "1.2",
    "definition": "A law established by repeated observation, such as conservation of mass. It summarises what nature does without explaining it."
  },
  {
    "term": "second (s)",
    "chapter": 1,
    "section": "1.6",
    "definition": "The SI base unit of time."
  },
  {
    "term": "significant figures (significant digits)",
    "chapter": 1,
    "section": "1.7",
    "definition": "The digits in a measurement that were actually measured, including one estimated digit. They record how good the measurement was, and they limit the answer."
  },
  {
    "term": "solid",
    "chapter": 1,
    "section": "1.3",
    "definition": "The state with fixed shape and volume: particles locked in place, vibrating but not moving past one another."
  },
  {
    "term": "state",
    "chapter": 1,
    "section": "1.3",
    "definition": "Which physical form matter is in — solid, liquid or gas — written in equations as (s), (l), (g), with (aq) for dissolved in water."
  },
  {
    "term": "substance",
    "chapter": 1,
    "section": "1.3",
    "definition": "Matter of one fixed composition; the same thing as a pure substance."
  },
  {
    "term": "systematic error",
    "chapter": 1,
    "section": "1.7",
    "definition": "Error that pushes every measurement the same way, from a method or instrument that is off. Averaging does not remove it; it limits accuracy."
  },
  {
    "term": "temperature",
    "chapter": 1,
    "section": "1.6",
    "definition": "A measure of the average kinetic energy of the particles — how hot something is, not how much heat it holds."
  },
  {
    "term": "theory",
    "chapter": 1,
    "section": "1.2",
    "definition": "A well-tested explanation of why the laws hold, able to predict results not yet measured. In science, theory means well supported, not guess."
  },
  {
    "term": "thermal energy",
    "chapter": 1,
    "section": "1.5",
    "definition": "The total kinetic energy of the particles in a sample. It depends on amount as well as temperature, which is why a bathtub holds more than a cup at the same temperature."
  },
  {
    "term": "units",
    "chapter": 1,
    "section": "1.6",
    "definition": "The standard quantity a measurement is counted in. A number without a unit is not an answer."
  },
  {
    "term": "volatile",
    "chapter": 1,
    "section": "1.3",
    "definition": "Easily evaporated, because the substance boils at a low temperature. Rubbing alcohol is volatile; motor oil is not."
  },
  {
    "term": "volume (V)",
    "chapter": 1,
    "section": "1.6",
    "definition": "The space something occupies, in L, mL or cm³."
  },
  {
    "term": "work (w)",
    "chapter": 1,
    "section": "1.5",
    "definition": "Energy transferred by moving something against a force. For a gas pushing against constant pressure, w = −PΔV."
  },
  {
    "term": "atomic mass (atomic weight)",
    "chapter": 2,
    "section": "2.8",
    "definition": "The weighted average mass of an element's atoms, in amu, weighted by how common each isotope is. The number printed under the symbol on your table."
  },
  {
    "term": "atomic mass unit (amu)",
    "chapter": 2,
    "section": "2.6",
    "definition": "The mass unit for atoms, defined as exactly 1/12 the mass of a carbon-12 atom, about 1.66 × 10⁻²⁴ g."
  },
  {
    "term": "atomic number (Z)",
    "chapter": 2,
    "section": "2.6",
    "definition": "The number of protons in the nucleus. It defines which element an atom is, and it is the number the table is ordered by."
  },
  {
    "term": "Avogadro’s number",
    "chapter": 2,
    "section": "2.9",
    "definition": "6.022 × 10²³, the number of particles in one mole. It is the bridge between counting atoms and weighing grams."
  },
  {
    "term": "cathode ray",
    "chapter": 2,
    "section": "2.4",
    "definition": "The beam that crosses an evacuated tube from the negative electrode. Showing it was deflected by charge is how the electron was found."
  },
  {
    "term": "cathode ray tube",
    "chapter": 2,
    "section": "2.4",
    "definition": "The evacuated tube, with electrodes at each end, used in the experiments that identified the electron."
  },
  {
    "term": "cation",
    "chapter": 2,
    "section": "2.6",
    "definition": "A positively charged ion, formed when an atom loses electrons. Metals form cations: Na⁺, Ca²⁺, Al³⁺."
  },
  {
    "term": "chemical symbol",
    "chapter": 2,
    "section": "2.6",
    "definition": "The one- or two-letter abbreviation for an element, first letter always capital: C, Ca, Cl, Co."
  },
  {
    "term": "electrical charge",
    "chapter": 2,
    "section": "2.4",
    "definition": "The property that makes particles attract or repel: like charges repel, opposite charges attract. Protons +1, electrons −1."
  },
  {
    "term": "electron",
    "chapter": 2,
    "section": "2.4",
    "definition": "The light, negatively charged particle outside the nucleus. Chemistry is almost entirely about what electrons do."
  },
  {
    "term": "family (group)",
    "chapter": 2,
    "section": "2.7",
    "definition": "A column of the periodic table. Members have the same number of valence electrons, so they behave alike."
  },
  {
    "term": "halogens",
    "chapter": 2,
    "section": "2.7",
    "definition": "Group 7A — F, Cl, Br, I, At. Very reactive nonmetals, one electron short of a full shell, so they form 1− ions."
  },
  {
    "term": "ion",
    "chapter": 2,
    "section": "2.6",
    "definition": "An atom or group of atoms carrying a charge, because it has lost or gained electrons."
  },
  {
    "term": "isotopes",
    "chapter": 2,
    "section": "2.6",
    "definition": "Atoms of the same element with different numbers of neutrons — same Z, different mass number. Chlorine-35 and chlorine-37."
  },
  {
    "term": "law of definite proportions",
    "chapter": 2,
    "section": "2.3",
    "definition": "A given compound always contains the same elements in the same mass ratio, no matter where the sample came from."
  },
  {
    "term": "law of multiple proportions",
    "chapter": 2,
    "section": "2.3",
    "definition": "When two elements form more than one compound, the masses of one element combining with a fixed mass of the other are in small whole-number ratios. CO and CO₂."
  },
  {
    "term": "main-group elements",
    "chapter": 2,
    "section": "2.7",
    "definition": "The elements in groups 1A–8A, the tall columns at the edges of the table. Their behaviour is the most predictable from their group."
  },
  {
    "term": "mass number (A)",
    "chapter": 2,
    "section": "2.6",
    "definition": "Protons plus neutrons in a particular atom — a whole number, specific to one isotope, unlike the atomic mass."
  },
  {
    "term": "mass spectrometry",
    "chapter": 2,
    "section": "2.8",
    "definition": "Separating ions by mass by bending their path in a magnetic field. It is how isotope abundances are measured."
  },
  {
    "term": "metal",
    "chapter": 2,
    "section": "2.7",
    "definition": "An element that is shiny, conducts heat and electricity, is malleable, and tends to lose electrons. The left and middle of the table."
  },
  {
    "term": "metalloid",
    "chapter": 2,
    "section": "2.7",
    "definition": "An element along the staircase — B, Si, Ge, As, Sb, Te — with properties between metal and nonmetal."
  },
  {
    "term": "molar mass",
    "chapter": 2,
    "section": "2.9",
    "definition": "The mass of one mole of a substance, in g/mol. Numerically the same as the atomic or formula mass, and the factor that turns grams into moles."
  },
  {
    "term": "mole (mol)",
    "chapter": 2,
    "section": "2.9",
    "definition": "The chemist's counting unit: 6.022 × 10²³ particles, chosen so that one mole of an element weighs its atomic mass in grams."
  },
  {
    "term": "natural abundance",
    "chapter": 2,
    "section": "2.6",
    "definition": "The percentage of an element's atoms, as found on Earth, that are a particular isotope. These are the weights in the atomic-mass average."
  },
  {
    "term": "neutron",
    "chapter": 2,
    "section": "2.5",
    "definition": "The uncharged nuclear particle, mass about equal to the proton's. It changes the mass of an atom but not its chemistry."
  },
  {
    "term": "noble gases",
    "chapter": 2,
    "section": "2.7",
    "definition": "Group 8A — He, Ne, Ar, Kr, Xe, Rn. Full outer shells, so they are almost unreactive. The configuration every other atom is trying to reach."
  },
  {
    "term": "nonmetal",
    "chapter": 2,
    "section": "2.7",
    "definition": "An element that is dull, brittle, a poor conductor, and tends to gain electrons. The upper right of the table."
  },
  {
    "term": "nuclear theory",
    "chapter": 2,
    "section": "2.5",
    "definition": "The model of the atom with nearly all the mass in a tiny dense positive nucleus and the electrons in the huge volume around it."
  },
  {
    "term": "nucleus",
    "chapter": 2,
    "section": "2.5",
    "definition": "The small, dense, positively charged centre of the atom, holding the protons and neutrons and nearly all the mass."
  },
  {
    "term": "periodic law",
    "chapter": 2,
    "section": "2.7",
    "definition": "Arranged by atomic number, elements repeat their properties at regular intervals. That repetition is what the table's shape records."
  },
  {
    "term": "proton",
    "chapter": 2,
    "section": "2.5",
    "definition": "The positively charged nuclear particle. How many there are is what element it is."
  },
  {
    "term": "radioactivity",
    "chapter": 2,
    "section": "2.5",
    "definition": "Spontaneous emission of particles or energy from unstable nuclei."
  },
  {
    "term": "semiconductor",
    "chapter": 2,
    "section": "2.7",
    "definition": "A material that conducts electricity only partly, and more when warmed or doped. The metalloids, silicon above all."
  },
  {
    "term": "transition elements (transition metals)",
    "chapter": 2,
    "section": "2.7",
    "definition": "The metals in the middle block, groups 1B–8B, where d orbitals are filling. Many form more than one charge, so their names need Roman numerals."
  },
  {
    "term": "ball-and-stick molecular model",
    "chapter": 3,
    "section": "3.3",
    "definition": "A model drawing atoms as balls and bonds as sticks. It shows bond angles and shape clearly, but exaggerates the empty space."
  },
  {
    "term": "binary acid",
    "chapter": 3,
    "section": "3.6",
    "definition": "An acid of hydrogen and one other element: HCl, HBr, H₂S. Named hydro-(root)-ic acid."
  },
  {
    "term": "binary compound",
    "chapter": 3,
    "section": "3.5",
    "definition": "A compound of exactly two elements."
  },
  {
    "term": "chemical formula",
    "chapter": 3,
    "section": "3.3",
    "definition": "The symbols and subscripts giving which elements are in a compound and in what ratio: CaCl₂, C₆H₁₂O₆."
  },
  {
    "term": "combustion analysis",
    "chapter": 3,
    "section": "3.10",
    "definition": "Burning a sample completely and weighing the CO₂ and H₂O produced, to work back to the empirical formula."
  },
  {
    "term": "common name",
    "chapter": 3,
    "section": "3.5",
    "definition": "A traditional name that does not describe the composition — water, ammonia, laughing gas — and so has to be memorised."
  },
  {
    "term": "covalent bond",
    "chapter": 3,
    "section": "3.2",
    "definition": "A bond in which two atoms share a pair of electrons. The bond between nonmetals."
  },
  {
    "term": "empirical formula",
    "chapter": 3,
    "section": "3.3",
    "definition": "The simplest whole-number ratio of atoms in a compound. Hydrogen peroxide H₂O₂ has empirical formula HO."
  },
  {
    "term": "empirical formula molar mass",
    "chapter": 3,
    "section": "3.10",
    "definition": "The mass of one mole of the empirical formula unit. Dividing the true molar mass by it gives the whole number to multiply the empirical formula by."
  },
  {
    "term": "family",
    "chapter": 3,
    "section": "3.11",
    "definition": "A group of compounds sharing a characteristic structure and so behaving alike, such as the alcohols."
  },
  {
    "term": "formula mass",
    "chapter": 3,
    "section": "3.8",
    "definition": "The sum of the atomic masses in a formula unit, used for ionic compounds, where molecule would be the wrong word."
  },
  {
    "term": "formula unit",
    "chapter": 3,
    "section": "3.4",
    "definition": "The smallest whole-number ratio of ions in an ionic compound — NaCl — which is a bookkeeping unit, not a real particle, since the crystal is a continuous lattice."
  },
  {
    "term": "hydrate",
    "chapter": 3,
    "section": "3.5",
    "definition": "An ionic compound with a definite number of water molecules in its crystal, written with a dot: CuSO₄·5H₂O."
  },
  {
    "term": "hydrocarbon",
    "chapter": 3,
    "section": "3.11",
    "definition": "A compound of only carbon and hydrogen: methane, propane, octane. The fuels."
  },
  {
    "term": "ionic bond",
    "chapter": 3,
    "section": "3.2",
    "definition": "The attraction holding a lattice of cations and anions together, after a metal transfers electrons to a nonmetal."
  },
  {
    "term": "ionic compound",
    "chapter": 3,
    "section": "3.2",
    "definition": "A compound of a metal with a nonmetal (or with a polyatomic ion), built as a lattice of ions. Hard, high melting, conducts when dissolved."
  },
  {
    "term": "mass percent composition (mass percent)",
    "chapter": 3,
    "section": "3.9",
    "definition": "The percentage of a compound's mass contributed by one element: (mass of element in 1 mol / molar mass) × 100 %."
  },
  {
    "term": "molecular compound",
    "chapter": 3,
    "section": "3.2",
    "definition": "A compound of nonmetals, built from discrete molecules. Lower melting, often gases or liquids, and does not conduct."
  },
  {
    "term": "molecular element",
    "chapter": 3,
    "section": "3.4",
    "definition": "An element that occurs naturally as molecules, not single atoms: H₂, N₂, O₂, F₂, Cl₂, Br₂, I₂, and P₄ and S₈."
  },
  {
    "term": "molecular formula",
    "chapter": 3,
    "section": "3.3",
    "definition": "The actual number of each atom in one molecule, which is the empirical formula times a whole number. Glucose is C₆H₁₂O₆, not CH₂O."
  },
  {
    "term": "organic compound",
    "chapter": 3,
    "section": "3.12",
    "definition": "A compound built on a carbon skeleton, usually with hydrogen. The subject of a whole later course."
  },
  {
    "term": "organic molecule",
    "chapter": 3,
    "section": "3.11",
    "definition": "A molecule of an organic compound — carbon-based, usually with C–H bonds."
  },
  {
    "term": "oxyacid",
    "chapter": 3,
    "section": "3.6",
    "definition": "An acid containing hydrogen, oxygen and one other element: HNO₃, H₂SO₄. The -ate ion gives -ic acid, the -ite ion gives -ous acid."
  },
  {
    "term": "oxyanion",
    "chapter": 3,
    "section": "3.5",
    "definition": "A polyatomic anion containing oxygen: NO₃⁻, SO₄²⁻, ClO₃⁻. More oxygen takes -ate, less takes -ite."
  },
  {
    "term": "polyatomic ion",
    "chapter": 3,
    "section": "3.4",
    "definition": "A group of atoms bonded together that carries one overall charge and travels as a unit: NO₃⁻, SO₄²⁻, NH₄⁺. Worth memorising cold."
  },
  {
    "term": "space-filling molecular model",
    "chapter": 3,
    "section": "3.3",
    "definition": "A model with atoms as overlapping spheres at their real relative sizes, which shows the true bulk but hides the bonds."
  },
  {
    "term": "structural formula",
    "chapter": 3,
    "section": "3.3",
    "definition": "A formula showing which atom is bonded to which, with lines for bonds, rather than only the counts."
  },
  {
    "term": "systematic name",
    "chapter": 3,
    "section": "3.5",
    "definition": "A name built by rules so that it describes the composition, and so can be worked out rather than memorised: dinitrogen tetroxide."
  },
  {
    "term": "balanced chemical equation",
    "chapter": 4,
    "section": "4.2",
    "definition": "An equation with coefficients chosen so each element has the same number of atoms on both sides, as conservation of mass requires. Only coefficients may be changed, never subscripts."
  },
  {
    "term": "chemical equation",
    "chapter": 4,
    "section": "4.2",
    "definition": "The written form of a reaction, reactants on the left, products on the right, arrow between."
  },
  {
    "term": "chemical reaction",
    "chapter": 4,
    "section": "4.2",
    "definition": "A process in which bonds break and form so that one set of substances becomes another."
  },
  {
    "term": "combustion reaction",
    "chapter": 4,
    "section": "4.2",
    "definition": "A reaction with O₂ that releases heat. A hydrocarbon burned completely gives CO₂ and H₂O."
  },
  {
    "term": "excess (reactants)",
    "chapter": 4,
    "section": "4.4",
    "definition": "The reactants not fully used up, because something else ran out first. Whatever is left when the reaction stops."
  },
  {
    "term": "limiting reactant",
    "chapter": 4,
    "section": "4.4",
    "definition": "The reactant that runs out first and so sets how much product can form. Find it by converting every reactant to moles of product and taking the smallest."
  },
  {
    "term": "percent yield",
    "chapter": 4,
    "section": "4.4",
    "definition": "(actual yield / theoretical yield) × 100 %. How much of what should have formed actually did."
  },
  {
    "term": "products",
    "chapter": 4,
    "section": "4.2",
    "definition": "The substances formed, written on the right of the arrow."
  },
  {
    "term": "reactants",
    "chapter": 4,
    "section": "4.2",
    "definition": "The starting substances, written on the left of the arrow."
  },
  {
    "term": "stoichiometry",
    "chapter": 4,
    "section": "4.3",
    "definition": "Using the coefficients of a balanced equation as a mole ratio to get from an amount of one substance to an amount of another. Grams → moles → moles → grams."
  },
  {
    "term": "theoretical yield",
    "chapter": 4,
    "section": "4.4",
    "definition": "The most product the limiting reactant could possibly give, from the stoichiometry. Reality is always less."
  },
  {
    "term": "complete ionic equation",
    "chapter": 5,
    "section": "5.6",
    "definition": "An equation with every strong electrolyte written as the separate ions it really exists as in water."
  },
  {
    "term": "concentrated solution",
    "chapter": 5,
    "section": "5.2",
    "definition": "A solution holding a large amount of solute per volume."
  },
  {
    "term": "dilute solution",
    "chapter": 5,
    "section": "5.2",
    "definition": "A solution holding a small amount of solute per volume."
  },
  {
    "term": "diprotic acid",
    "chapter": 5,
    "section": "5.7",
    "definition": "An acid with two ionisable hydrogens, given up one at a time: H₂SO₄, H₂CO₃."
  },
  {
    "term": "electrolyte",
    "chapter": 5,
    "section": "5.4",
    "definition": "A substance whose solution conducts electricity, because dissolving it produces ions."
  },
  {
    "term": "equivalence point",
    "chapter": 5,
    "section": "5.7",
    "definition": "The point in a titration where the added titrant exactly matches the substance being measured in stoichiometric amount. The indicator changing colour is how you see it."
  },
  {
    "term": "gas-evolution reaction",
    "chapter": 5,
    "section": "5.7",
    "definition": "A reaction producing a gas that bubbles out, often through an unstable intermediate: carbonates with acid give CO₂ via H₂CO₃."
  },
  {
    "term": "hydronium ion",
    "chapter": 5,
    "section": "5.7",
    "definition": "H₃O⁺, what a proton actually is in water. H⁺(aq) is shorthand for it."
  },
  {
    "term": "indicator",
    "chapter": 5,
    "section": "5.7",
    "definition": "A dye that changes colour over a narrow pH range, used to show the end of a titration."
  },
  {
    "term": "insoluble",
    "chapter": 5,
    "section": "5.4",
    "definition": "Not dissolving to any appreciable extent. In a precipitation reaction, the insoluble product is the solid that drops out."
  },
  {
    "term": "molarity (M)",
    "chapter": 5,
    "section": "5.2",
    "definition": "Moles of solute per litre of solution, M = mol/L. The concentration unit that makes volume usable as an amount."
  },
  {
    "term": "molecular equation",
    "chapter": 5,
    "section": "5.6",
    "definition": "An equation with every compound written whole, as if undissociated, even the ones that are really ions in solution."
  },
  {
    "term": "net ionic equation",
    "chapter": 5,
    "section": "5.6",
    "definition": "The complete ionic equation with the spectator ions cancelled, leaving only what chemically changed."
  },
  {
    "term": "nonelectrolyte",
    "chapter": 5,
    "section": "5.4",
    "definition": "A substance that dissolves without forming ions, so its solution does not conduct. Sugar in water."
  },
  {
    "term": "oxidation",
    "chapter": 5,
    "section": "5.9",
    "definition": "Loss of electrons, which shows up as the oxidation state going up. LEO: lose electrons, oxidation."
  },
  {
    "term": "oxidation state (oxidation number)",
    "chapter": 5,
    "section": "5.9",
    "definition": "The charge an atom would have if every bond were fully ionic. A bookkeeping device for tracking where electrons went."
  },
  {
    "term": "oxidation–reduction (redox) reaction",
    "chapter": 5,
    "section": "5.9",
    "definition": "A reaction in which electrons move from one substance to another, so oxidation states change. One species is oxidised, another reduced, always together."
  },
  {
    "term": "oxidizing agent",
    "chapter": 5,
    "section": "5.9",
    "definition": "The substance that takes the electrons, and so is itself reduced."
  },
  {
    "term": "polyprotic acid",
    "chapter": 5,
    "section": "5.7",
    "definition": "An acid with more than one ionisable hydrogen, lost in successive steps, each harder than the last."
  },
  {
    "term": "precipitate",
    "chapter": 5,
    "section": "5.5",
    "definition": "The insoluble solid that appears when two solutions are mixed."
  },
  {
    "term": "precipitation reaction",
    "chapter": 5,
    "section": "5.5",
    "definition": "Two solutions mixed, and an insoluble product forms and drops out. Which product that is comes from the solubility rules."
  },
  {
    "term": "reducing agent",
    "chapter": 5,
    "section": "5.9",
    "definition": "The substance that gives up the electrons, and so is itself oxidised."
  },
  {
    "term": "reduction",
    "chapter": 5,
    "section": "5.9",
    "definition": "Gain of electrons, which shows up as the oxidation state going down. GER: gain electrons, reduction."
  },
  {
    "term": "salt",
    "chapter": 5,
    "section": "5.7",
    "definition": "The ionic compound formed along with water when an acid neutralises a base. Not only table salt."
  },
  {
    "term": "soluble",
    "chapter": 5,
    "section": "5.4",
    "definition": "Dissolving appreciably in the solvent, so it stays in solution rather than precipitating."
  },
  {
    "term": "solute",
    "chapter": 5,
    "section": "5.2",
    "definition": "The substance dissolved — the smaller part of the solution."
  },
  {
    "term": "solution",
    "chapter": 5,
    "section": "5.2",
    "definition": "A homogeneous mixture of solute in solvent, uniform right down to the particle level."
  },
  {
    "term": "solvent",
    "chapter": 5,
    "section": "5.2",
    "definition": "The substance doing the dissolving — the larger part. Usually water, which is what (aq) records."
  },
  {
    "term": "spectator ion",
    "chapter": 5,
    "section": "5.6",
    "definition": "An ion present in solution before and after, unchanged, on both sides of the equation. It cancels out of the net ionic equation."
  },
  {
    "term": "stock solution",
    "chapter": 5,
    "section": "5.2",
    "definition": "A concentrated solution kept on the shelf and diluted to whatever is needed, using M₁V₁ = M₂V₂."
  },
  {
    "term": "strong acid",
    "chapter": 5,
    "section": "5.4",
    "definition": "An acid that ionises completely in water: HCl, HBr, HI, HNO₃, HClO₄, H₂SO₄. Worth memorising the list; everything else is weak."
  },
  {
    "term": "strong electrolyte",
    "chapter": 5,
    "section": "5.4",
    "definition": "A substance that dissociates completely in water, so its solution conducts well. Soluble salts, strong acids, strong bases."
  },
  {
    "term": "titration",
    "chapter": 5,
    "section": "5.7",
    "definition": "Adding a solution of known concentration from a burette until the reaction is just complete, to find an unknown concentration."
  },
  {
    "term": "weak acid",
    "chapter": 5,
    "section": "5.4",
    "definition": "An acid that only partly ionises, leaving an equilibrium between the acid and its ions. Acetic acid, HF."
  },
  {
    "term": "weak electrolyte",
    "chapter": 5,
    "section": "5.4",
    "definition": "A substance only partly ionised in solution, so its solution conducts poorly."
  },
  {
    "term": "Avogadro’s law",
    "chapter": 6,
    "section": "6.3",
    "definition": "At fixed temperature and pressure, volume is proportional to moles: V ∝ n, so V₁/n₁ = V₂/n₂. Equal volumes of any gases hold equal numbers of particles."
  },
  {
    "term": "barometer",
    "chapter": 6,
    "section": "6.2",
    "definition": "An instrument measuring atmospheric pressure by how high a column of mercury the air can hold up."
  },
  {
    "term": "Boyle’s law",
    "chapter": 6,
    "section": "6.3",
    "definition": "At fixed temperature, pressure and volume are inversely proportional: P₁V₁ = P₂V₂. Squeeze a gas and the pressure rises."
  },
  {
    "term": "Charles’s law",
    "chapter": 6,
    "section": "6.3",
    "definition": "At fixed pressure, volume is proportional to absolute temperature: V₁/T₁ = V₂/T₂. In kelvins, always."
  },
  {
    "term": "Dalton’s law of partial pressures",
    "chapter": 6,
    "section": "6.6",
    "definition": "The total pressure of a gas mixture is the sum of the pressures each gas would exert on its own."
  },
  {
    "term": "diffusion",
    "chapter": 6,
    "section": "6.9",
    "definition": "The spreading of one gas through another by random molecular motion, which is why a smell crosses a room."
  },
  {
    "term": "effusion",
    "chapter": 6,
    "section": "6.9",
    "definition": "Escape of a gas through a tiny hole into a vacuum. Lighter molecules effuse faster."
  },
  {
    "term": "Graham’s law of effusion",
    "chapter": 6,
    "section": "6.9",
    "definition": "Effusion rate goes as 1/√(molar mass), so rate_A/rate_B = √(M_B/M_A). A molecule four times heavier escapes half as fast."
  },
  {
    "term": "hypoxia",
    "chapter": 6,
    "section": "6.6",
    "definition": "Too little oxygen reaching the tissues, from a partial pressure of O₂ that is too low — the problem at altitude."
  },
  {
    "term": "ideal gas",
    "chapter": 6,
    "section": "6.4",
    "definition": "A gas that obeys PV = nRT exactly, which assumes the particles have no volume and no attraction for one another. Real gases come close at low pressure and high temperature."
  },
  {
    "term": "ideal gas constant",
    "chapter": 6,
    "section": "6.4",
    "definition": "R, the constant in PV = nRT: 0.08206 L·atm/(mol·K), or 8.314 J/(mol·K). Pick the one whose units match the question."
  },
  {
    "term": "ideal gas law",
    "chapter": 6,
    "section": "6.4",
    "definition": "PV = nRT, the one equation that contains Boyle, Charles and Avogadro at once."
  },
  {
    "term": "kinetic molecular theory",
    "chapter": 6,
    "section": "6.8",
    "definition": "The model behind the gas laws: particles in constant random motion, far apart, colliding elastically, with average kinetic energy set only by temperature."
  },
  {
    "term": "manometer",
    "chapter": 6,
    "section": "6.2",
    "definition": "A U-tube of liquid used to measure the pressure of an enclosed gas by the height difference between the two arms."
  },
  {
    "term": "mean free path",
    "chapter": 6,
    "section": "6.9",
    "definition": "The average distance a particle travels between collisions — very long compared with the particle in a gas."
  },
  {
    "term": "millimeter of mercury (mmHg)",
    "chapter": 6,
    "section": "6.2",
    "definition": "A pressure unit: the pressure holding up 1 mm of mercury. 760 mmHg = 1 atm."
  },
  {
    "term": "molar volume",
    "chapter": 6,
    "section": "6.5",
    "definition": "The volume of one mole of gas, 22.414 L at STP, which follows straight from PV = nRT."
  },
  {
    "term": "mole fraction (χA)",
    "chapter": 6,
    "section": "6.6",
    "definition": "Moles of one component over total moles. Multiplied by total pressure it gives that component's partial pressure."
  },
  {
    "term": "nitrogen narcosis",
    "chapter": 6,
    "section": "6.6",
    "definition": "The confusion divers get when breathing air under pressure, because nitrogen at a high partial pressure dissolves into the nervous system."
  },
  {
    "term": "oxygen toxicity",
    "chapter": 6,
    "section": "6.6",
    "definition": "The harm done by breathing oxygen at too high a partial pressure, the reason deep-diving mixtures are oxygen-poor."
  },
  {
    "term": "partial pressure (Pn)",
    "chapter": 6,
    "section": "6.6",
    "definition": "The pressure one gas in a mixture would exert if it alone filled the container."
  },
  {
    "term": "pascal (Pa)",
    "chapter": 6,
    "section": "6.2",
    "definition": "The SI unit of pressure, one newton per square metre. 101 325 Pa = 1 atm, so it is a small unit."
  },
  {
    "term": "pressure",
    "chapter": 6,
    "section": "6.1",
    "definition": "Force per unit area. For a gas, the result of its particles hammering on the walls."
  },
  {
    "term": "standard temperature and pressure (STP)",
    "chapter": 6,
    "section": "6.5",
    "definition": "0 °C and 1 atm, the agreed reference conditions where a mole of gas occupies 22.414 L."
  },
  {
    "term": "torr",
    "chapter": 6,
    "section": "6.2",
    "definition": "A pressure unit equal to 1 mmHg; 760 torr = 1 atm."
  },
  {
    "term": "van der Waals equation",
    "chapter": 6,
    "section": "6.10",
    "definition": "The ideal gas law corrected for real gases, with a for the attraction between particles and b for their own volume: (P + an²/V²)(V − nb) = nRT."
  },
  {
    "term": "vapor pressure",
    "chapter": 6,
    "section": "6.6",
    "definition": "The pressure of the vapour sitting above its own liquid at equilibrium. It must be subtracted when a gas is collected over water."
  },
  {
    "term": "bomb calorimeter",
    "chapter": 7,
    "section": "7.5",
    "definition": "A sealed, rigid, constant-volume calorimeter for burning a sample. Because the volume is fixed, it measures ΔE rather than ΔH."
  },
  {
    "term": "calorie (cal)",
    "chapter": 7,
    "section": "7.2",
    "definition": "The energy that raises 1 g of water by 1 °C: 4.184 J exactly."
  },
  {
    "term": "Calorie (Cal)",
    "chapter": 7,
    "section": "7.2",
    "definition": "The food Calorie, with a capital C — one kilocalorie, 1000 cal. A thousand times the other one, which is a favourite exam trap."
  },
  {
    "term": "calorimetry",
    "chapter": 7,
    "section": "7.5",
    "definition": "Measuring heat by measuring a temperature change in something of known heat capacity."
  },
  {
    "term": "chemical energy",
    "chapter": 7,
    "section": "7.2",
    "definition": "Potential energy stored in bonds and in the arrangement of electrons and nuclei, released or absorbed when they rearrange."
  },
  {
    "term": "coffee-cup calorimeter",
    "chapter": 7,
    "section": "7.7",
    "definition": "An insulated cup open to the air, so the pressure is constant: it measures ΔH, using q = mcΔT on the solution."
  },
  {
    "term": "endothermic reaction",
    "chapter": 7,
    "section": "7.6",
    "definition": "A reaction absorbing heat from its surroundings, so ΔH is positive and the beaker feels cold."
  },
  {
    "term": "enthalpy (H)",
    "chapter": 7,
    "section": "7.6",
    "definition": "The heat content of a system at constant pressure, H = E + PV. A state function, so only its change matters."
  },
  {
    "term": "enthalpy (heat) of reaction (∆Hrxn)",
    "chapter": 7,
    "section": "7.6",
    "definition": "The heat given out or taken in by a reaction at constant pressure, per mole as the equation is written. Negative means exothermic."
  },
  {
    "term": "first law of thermodynamics",
    "chapter": 7,
    "section": "7.3",
    "definition": "Energy is conserved: ΔE = q + w. You can move energy or change its form, but you cannot make or destroy it."
  },
  {
    "term": "functional group",
    "chapter": 7,
    "section": "7.6",
    "definition": "A characteristic cluster of atoms that gives a family of organic molecules its behaviour — –OH, –COOH, –NH₂."
  },
  {
    "term": "heat (q)",
    "chapter": 7,
    "section": "7.2",
    "definition": "Energy moving because of a temperature difference, always from hot to cold. Heat is a transfer, not a thing something contains."
  },
  {
    "term": "heat capacity (C)",
    "chapter": 7,
    "section": "7.4",
    "definition": "The heat needed to raise an object's temperature by 1 °C. It depends on how much there is, so it is extensive."
  },
  {
    "term": "Hess’s law",
    "chapter": 7,
    "section": "7.8",
    "definition": "ΔH for an overall reaction is the sum of the ΔH values of any steps adding up to it. Reverse a step and flip the sign; multiply a step and multiply ΔH."
  },
  {
    "term": "internal energy (E)",
    "chapter": 7,
    "section": "7.3",
    "definition": "The total energy of a system, kinetic and potential, of all its particles. A state function."
  },
  {
    "term": "joule (J)",
    "chapter": 7,
    "section": "7.2",
    "definition": "The SI unit of energy, 1 kg·m²/s². Small: one calorie is 4.184 J."
  },
  {
    "term": "kilowatt-hour (kWh)",
    "chapter": 7,
    "section": "7.2",
    "definition": "The energy unit on an electricity bill, 3.6 × 10⁶ J — a kilowatt drawn for an hour."
  },
  {
    "term": "molar heat capacity",
    "chapter": 7,
    "section": "7.4",
    "definition": "The heat needed to raise one mole by 1 °C, in J/(mol·°C)."
  },
  {
    "term": "pressure–volume work",
    "chapter": 7,
    "section": "7.4",
    "definition": "The work a gas does by expanding against a pressure, w = −PΔV. Expanding does work on the surroundings, so w is negative."
  },
  {
    "term": "specific heat capacity (Cs)",
    "chapter": 7,
    "section": "7.4",
    "definition": "The heat needed to raise 1 g by 1 °C, in J/(g·°C). Water's is 4.184, unusually high, which is why oceans moderate climate."
  },
  {
    "term": "standard enthalpy (heat) of formation (∆H°f)",
    "chapter": 7,
    "section": "7.9",
    "definition": "The enthalpy change forming one mole of a substance from its elements in their standard states. Zero, by definition, for an element in its standard state."
  },
  {
    "term": "standard enthalpy change (∆H°)",
    "chapter": 7,
    "section": "7.9",
    "definition": "The enthalpy change with everything in its standard state, so that values from different reactions can be added."
  },
  {
    "term": "standard state",
    "chapter": 7,
    "section": "7.9",
    "definition": "The agreed reference condition for tabulated values: the pure substance at 1 atm, solutions at 1 M, usually quoted at 25 °C."
  },
  {
    "term": "state function",
    "chapter": 7,
    "section": "7.3",
    "definition": "A property depending only on the present state, not the route taken to it. Enthalpy and internal energy are; heat and work are not."
  },
  {
    "term": "surroundings",
    "chapter": 7,
    "section": "7.2",
    "definition": "Everything outside the system that can exchange energy with it."
  },
  {
    "term": "system",
    "chapter": 7,
    "section": "7.2",
    "definition": "The part of the universe being studied — usually the reaction mixture."
  },
  {
    "term": "thermal equilibrium",
    "chapter": 7,
    "section": "7.4",
    "definition": "The state reached when two things in contact are at the same temperature, so no net heat flows."
  },
  {
    "term": "thermochemistry",
    "chapter": 7,
    "section": "7.1",
    "definition": "The study of the heat given out and taken in by chemical reactions."
  },
  {
    "term": "thermodynamics",
    "chapter": 7,
    "section": "7.3",
    "definition": "The study of energy, heat, work, and which direction a change will go."
  },
  {
    "term": "complementary properties",
    "chapter": 8,
    "section": "8.4",
    "definition": "A pair of properties you cannot both pin down at once, because measuring one disturbs the other. Position and momentum of an electron."
  },
  {
    "term": "constructive interference",
    "chapter": 8,
    "section": "8.2",
    "definition": "Two waves meeting in step so they add, giving a bigger amplitude. In bonding it is what makes a bonding orbital."
  },
  {
    "term": "de Broglie relation",
    "chapter": 8,
    "section": "8.4",
    "definition": "λ = h/(mv): anything with momentum has a wavelength. Large for an electron, meaninglessly small for a baseball."
  },
  {
    "term": "destructive interference",
    "chapter": 8,
    "section": "8.2",
    "definition": "Two waves meeting out of step so they cancel, leaving less amplitude or none."
  },
  {
    "term": "deterministic",
    "chapter": 8,
    "section": "8.4",
    "definition": "Describing a system whose future follows exactly from its present. Classical physics is; the electron is not."
  },
  {
    "term": "diamagnetic",
    "chapter": 8,
    "section": "8.2",
    "definition": "Having all electrons paired, so the substance is weakly pushed out of a magnetic field."
  },
  {
    "term": "diffraction",
    "chapter": 8,
    "section": "8.2",
    "definition": "The bending and spreading of a wave at an edge or through a slit. Electrons doing it is the proof they behave as waves."
  },
  {
    "term": "electromagnetic radiation",
    "chapter": 8,
    "section": "8.2",
    "definition": "Energy travelling as oscillating electric and magnetic fields, at the speed of light. Light, radio, X-rays — the same thing at different wavelengths."
  },
  {
    "term": "electromagnetic spectrum",
    "chapter": 8,
    "section": "8.2",
    "definition": "The whole range of electromagnetic radiation, from radio at the long-wavelength end to gamma rays at the short, energetic end."
  },
  {
    "term": "emission spectrum",
    "chapter": 8,
    "section": "8.3",
    "definition": "The particular set of wavelengths an excited element gives out — a line spectrum, a fingerprint, and the evidence that energy levels are quantised."
  },
  {
    "term": "frequency (ν)",
    "chapter": 8,
    "section": "8.2",
    "definition": "Wave cycles per second, in hertz. ν = c/λ, and E = hν, so high frequency means short wavelength and high energy."
  },
  {
    "term": "gamma (γ) ray",
    "chapter": 8,
    "section": "8.2",
    "definition": "The shortest-wavelength, highest-energy electromagnetic radiation, from nuclear processes. Ionising and dangerous."
  },
  {
    "term": "Heisenberg’s uncertainty principle",
    "chapter": 8,
    "section": "8.4",
    "definition": "You cannot know an electron's position and momentum both exactly: Δx·Δ(mv) ≥ h/4π. Not a limit of the equipment, a property of nature."
  },
  {
    "term": "indeterminacy",
    "chapter": 8,
    "section": "8.4",
    "definition": "The fact that an electron's path is not knowable even in principle — only probabilities are. What replaced the idea of an orbit."
  },
  {
    "term": "infrared (IR) radiation",
    "chapter": 8,
    "section": "8.2",
    "definition": "Radiation just longer than visible red, felt as heat, and absorbed by molecular vibrations, which is what makes IR spectra useful."
  },
  {
    "term": "interference",
    "chapter": 8,
    "section": "8.2",
    "definition": "What happens when waves overlap and add, reinforcing or cancelling. A defining behaviour of waves."
  },
  {
    "term": "magnetic quantum number (mℓ)",
    "chapter": 8,
    "section": "8.5",
    "definition": "The quantum number for an orbital's orientation in space, running from −ℓ to +ℓ. It is why there are three p orbitals and five d."
  },
  {
    "term": "microwaves",
    "chapter": 8,
    "section": "8.2",
    "definition": "Radiation between infrared and radio waves, absorbed by rotating water molecules, which is how a microwave oven heats food."
  },
  {
    "term": "node",
    "chapter": 8,
    "section": "8.6",
    "definition": "A place where the wave function is zero, so the electron is never found there. The pattern of nodes is what makes orbital shapes."
  },
  {
    "term": "orbital",
    "chapter": 8,
    "section": "8.5",
    "definition": "A solution of the wave equation — a region with a shape and an energy where an electron is likely to be found. Not a path."
  },
  {
    "term": "phase",
    "chapter": 8,
    "section": "8.6",
    "definition": "The sign, plus or minus, of a wave function in a region. Phases are what make orbitals add constructively or destructively when bonding."
  },
  {
    "term": "photoelectric effect",
    "chapter": 8,
    "section": "8.2",
    "definition": "Light ejecting electrons from a metal, but only above a threshold frequency however bright. The result that forced light to be treated as particles."
  },
  {
    "term": "photon (quantum)",
    "chapter": 8,
    "section": "8.2",
    "definition": "One indivisible packet of light, carrying E = hν. Light is a stream of these."
  },
  {
    "term": "principal level (shell)",
    "chapter": 8,
    "section": "8.5",
    "definition": "All the orbitals sharing one value of n. Shell n holds up to 2n² electrons."
  },
  {
    "term": "principal quantum number (n)",
    "chapter": 8,
    "section": "8.5",
    "definition": "The whole number 1, 2, 3 … setting an orbital's size and main energy. Bigger n means further out and higher energy."
  },
  {
    "term": "probability density",
    "chapter": 8,
    "section": "8.6",
    "definition": "How likely the electron is to be found per unit volume at a point — ψ² . What the pictures of orbitals actually show."
  },
  {
    "term": "quantum number",
    "chapter": 8,
    "section": "8.5",
    "definition": "One of the four numbers (n, ℓ, mℓ, mₛ) that label an electron's state. No two electrons in an atom share all four."
  },
  {
    "term": "quantum-mechanical model",
    "chapter": 8,
    "section": "8.1",
    "definition": "The current model of the atom: electrons as standing waves described by probabilities, not particles on orbits."
  },
  {
    "term": "radial distribution function",
    "chapter": 8,
    "section": "8.6",
    "definition": "The probability of finding the electron at a given distance from the nucleus, totalled over the whole shell at that radius. It gives each orbital its peaks."
  },
  {
    "term": "radio waves",
    "chapter": 8,
    "section": "8.2",
    "definition": "The longest-wavelength, lowest-energy electromagnetic radiation."
  },
  {
    "term": "spin quantum number (ms)",
    "chapter": 8,
    "section": "8.5",
    "definition": "+½ or −½, the two orientations of electron spin. It is why an orbital holds two electrons and no more."
  },
  {
    "term": "sublevel (subshell)",
    "chapter": 8,
    "section": "8.5",
    "definition": "The orbitals within a shell sharing one value of ℓ — the s, p, d and f sets."
  },
  {
    "term": "ultraviolet (UV) radiation",
    "chapter": 8,
    "section": "8.2",
    "definition": "Radiation just shorter than violet, energetic enough to break bonds and damage DNA."
  },
  {
    "term": "visible light",
    "chapter": 8,
    "section": "8.2",
    "definition": "The narrow band the eye detects, about 400 nm (violet) to 700 nm (red)."
  },
  {
    "term": "wave function (ψ)",
    "chapter": 8,
    "section": "8.5",
    "definition": "The mathematical solution of the Schrödinger equation describing an electron. Its square gives the probability of finding the electron somewhere."
  },
  {
    "term": "wavelength (λ)",
    "chapter": 8,
    "section": "8.2",
    "definition": "The distance between successive crests of a wave, usually in nm for light. λ = c/ν."
  },
  {
    "term": "X-ray",
    "chapter": 8,
    "section": "8.2",
    "definition": "High-energy, short-wavelength radiation that passes through soft tissue and is diffracted by crystals, which is how structures are determined."
  },
  {
    "term": "atomic radius",
    "chapter": 9,
    "section": "9.6",
    "definition": "A measure of the size of an atom. It decreases left to right across a period, as Zeff rises, and increases down a group."
  },
  {
    "term": "aufbau principle",
    "chapter": 9,
    "section": "9.3",
    "definition": "Fill orbitals from the lowest energy upward. Build-up, in German, and it is how configurations are written."
  },
  {
    "term": "core electrons",
    "chapter": 9,
    "section": "9.4",
    "definition": "The inner electrons, in filled shells below the valence shell. They shield the valence electrons and take almost no part in bonding."
  },
  {
    "term": "Coulomb’s law",
    "chapter": 9,
    "section": "9.3",
    "definition": "The force between charges goes as q₁q₂/r², so attraction grows with charge and falls off fast with distance. Behind nearly every periodic trend."
  },
  {
    "term": "covalent radius (bonding atomic radius)",
    "chapter": 9,
    "section": "9.6",
    "definition": "Half the distance between the nuclei of two bonded identical atoms."
  },
  {
    "term": "degenerate",
    "chapter": 9,
    "section": "9.3",
    "definition": "Having the same energy. The three p orbitals of a subshell are degenerate in an isolated atom."
  },
  {
    "term": "effective nuclear charge (Zeff)",
    "chapter": 9,
    "section": "9.3",
    "definition": "The pull the nucleus actually exerts on a valence electron, after the core electrons have shielded part of it. Roughly Z minus the core electrons."
  },
  {
    "term": "electron affinity (EA)",
    "chapter": 9,
    "section": "9.8",
    "definition": "The energy change when a gaseous atom gains an electron. More negative means the atom wants the electron more; the halogens are the extreme."
  },
  {
    "term": "electron configuration",
    "chapter": 9,
    "section": "9.3",
    "definition": "The list of which orbitals an atom's electrons occupy: 1s²2s²2p⁶…  It predicts the element's chemistry."
  },
  {
    "term": "ground state",
    "chapter": 9,
    "section": "9.3",
    "definition": "The lowest-energy arrangement — where the electrons sit unless something excites them."
  },
  {
    "term": "Hund’s rule",
    "chapter": 9,
    "section": "9.3",
    "definition": "Fill degenerate orbitals singly, with parallel spins, before pairing any of them up. Electrons spread out to avoid each other."
  },
  {
    "term": "ionization energy (IE)",
    "chapter": 9,
    "section": "9.7",
    "definition": "The energy to pull an electron off a gaseous atom. It rises across a period and falls down a group, and it jumps sharply once a full shell is reached."
  },
  {
    "term": "nonbonding atomic radius",
    "chapter": 9,
    "section": "9.6",
    "definition": "Half the closest approach of two atoms that are not bonded — a bigger number than the covalent radius."
  },
  {
    "term": "orbital diagram",
    "chapter": 9,
    "section": "9.3",
    "definition": "The boxes-and-arrows picture of a configuration, one box per orbital and arrows for spins. It shows pairing, so it shows magnetism."
  },
  {
    "term": "paramagnetic",
    "chapter": 9,
    "section": "9.7",
    "definition": "Having at least one unpaired electron, so the substance is drawn into a magnetic field."
  },
  {
    "term": "Pauli exclusion principle",
    "chapter": 9,
    "section": "9.3",
    "definition": "No two electrons in an atom may have all four quantum numbers the same, so an orbital holds at most two, with opposite spins."
  },
  {
    "term": "penetration",
    "chapter": 9,
    "section": "9.3",
    "definition": "How far an orbital's electron density reaches in toward the nucleus. More penetration means less shielding and lower energy, which is why 2s sits below 2p."
  },
  {
    "term": "periodic property",
    "chapter": 9,
    "section": "9.1",
    "definition": "A property that varies predictably across the table — radius, ionisation energy, electron affinity, electronegativity."
  },
  {
    "term": "shielding",
    "chapter": 9,
    "section": "9.3",
    "definition": "Core electrons getting between the nucleus and a valence electron and cancelling part of its pull."
  },
  {
    "term": "valence electrons",
    "chapter": 9,
    "section": "9.4",
    "definition": "The outermost electrons, in the highest occupied shell. They do the bonding, and the group number tells you how many there are."
  },
  {
    "term": "van der Waals radius",
    "chapter": 9,
    "section": "9.6",
    "definition": "Half the distance between two touching but unbonded atoms — the nonbonding radius, set by where repulsion stops them."
  },
  {
    "term": "bond energy",
    "chapter": 10,
    "section": "10.10",
    "definition": "The energy needed to break one mole of a bond in the gas phase. Summing bonds broken minus bonds formed estimates ΔHrxn."
  },
  {
    "term": "bond length",
    "chapter": 10,
    "section": "10.10",
    "definition": "The average distance between the nuclei of two bonded atoms. Stronger bonds are shorter: triple < double < single."
  },
  {
    "term": "bonding pair",
    "chapter": 10,
    "section": "10.5",
    "definition": "A pair of electrons shared between two atoms — one line in a Lewis structure."
  },
  {
    "term": "Born–Haber cycle",
    "chapter": 10,
    "section": "10.4",
    "definition": "A Hess's-law loop for an ionic compound, used to get the lattice energy, which cannot be measured directly, from steps that can."
  },
  {
    "term": "chemical bond",
    "chapter": 10,
    "section": "10.3",
    "definition": "The attraction holding atoms together, because the arrangement with the bond is lower in energy than the atoms apart."
  },
  {
    "term": "dipole moment (μ)",
    "chapter": 10,
    "section": "10.6",
    "definition": "The size of a molecule's separation of charge, from the charge difference times the distance. It is zero when the bond dipoles cancel by symmetry."
  },
  {
    "term": "double bond",
    "chapter": 10,
    "section": "10.5",
    "definition": "Two shared pairs between the same two atoms — shorter and stronger than a single bond, and not free to rotate."
  },
  {
    "term": "duet",
    "chapter": 10,
    "section": "10.3",
    "definition": "Two valence electrons, which is a full shell for hydrogen and helium. The octet rule's exception for the first row."
  },
  {
    "term": "electronegativity",
    "chapter": 10,
    "section": "10.6",
    "definition": "How strongly an atom pulls shared electrons toward itself. It rises up and to the right; fluorine is the highest."
  },
  {
    "term": "formal charge",
    "chapter": 10,
    "section": "10.8",
    "definition": "The charge an atom in a Lewis structure would carry if every bonding pair were split evenly: valence electrons − lone-pair electrons − half the bonding electrons. Used to choose between candidate structures."
  },
  {
    "term": "free radical",
    "chapter": 10,
    "section": "10.9",
    "definition": "A species with an unpaired electron, so it cannot satisfy the octet rule and is very reactive. NO, OH."
  },
  {
    "term": "lattice energy",
    "chapter": 10,
    "section": "10.4",
    "definition": "The energy released as gaseous ions come together into an ionic crystal. Large and negative, and larger with higher charges and smaller ions."
  },
  {
    "term": "Lewis electron-dot structures (Lewis structures)",
    "chapter": 10,
    "section": "10.1",
    "definition": "A drawing of a molecule with dots for lone pairs and lines for bonds, arranged so every atom reaches an octet. The basic tool for predicting structure."
  },
  {
    "term": "Lewis model",
    "chapter": 10,
    "section": "10.1",
    "definition": "The simple bonding theory in which atoms share or transfer electrons to reach a noble-gas octet. Crude, but it predicts a great deal."
  },
  {
    "term": "Lewis symbol",
    "chapter": 10,
    "section": "10.3",
    "definition": "An element's symbol with dots around it for its valence electrons."
  },
  {
    "term": "lone pair",
    "chapter": 10,
    "section": "10.5",
    "definition": "A valence pair belonging to one atom and not shared. Lone pairs take up space, so they shape the molecule."
  },
  {
    "term": "metallic bonding",
    "chapter": 10,
    "section": "10.2",
    "definition": "Metal cations in a shared sea of delocalised electrons. It explains conduction, lustre and malleability."
  },
  {
    "term": "nonbonding electrons",
    "chapter": 10,
    "section": "10.5",
    "definition": "The electrons not involved in bonding — the lone pairs."
  },
  {
    "term": "octet",
    "chapter": 10,
    "section": "10.3",
    "definition": "Eight valence electrons, the full s and p set, which is the arrangement most atoms are trying to reach."
  },
  {
    "term": "octet rule",
    "chapter": 10,
    "section": "10.3",
    "definition": "Atoms gain, lose or share electrons to end up with eight valence electrons. It has exceptions — H and He, boron and beryllium, and the expanded octets of period 3 onward."
  },
  {
    "term": "percent ionic character",
    "chapter": 10,
    "section": "10.6",
    "definition": "How ionic a bond really is, from the measured dipole moment over the one a full charge transfer would give. No bond is 100 % ionic."
  },
  {
    "term": "polar covalent bond",
    "chapter": 10,
    "section": "10.6",
    "definition": "A shared pair pulled unevenly because the two atoms differ in electronegativity, leaving one end partly negative."
  },
  {
    "term": "resonance hybrid",
    "chapter": 10,
    "section": "10.8",
    "definition": "The real structure, which is an average of the resonance forms and not any one of them. Resonance makes a molecule more stable than a single structure suggests."
  },
  {
    "term": "resonance structures",
    "chapter": 10,
    "section": "10.8",
    "definition": "Two or more Lewis structures with the same arrangement of atoms and different placements of electrons, needed because no one structure fits the evidence."
  },
  {
    "term": "triple bond",
    "chapter": 10,
    "section": "10.5",
    "definition": "Three shared pairs between the same two atoms. The shortest and strongest, as in N₂."
  },
  {
    "term": "bent geometry",
    "chapter": 11,
    "section": "11.3",
    "definition": "The shape of a molecule with two bonded atoms and one or two lone pairs on the central atom, so the bonds are pushed to an angle. Water, about 104.5°."
  },
  {
    "term": "bond order",
    "chapter": 11,
    "section": "11.8",
    "definition": "Half the difference between bonding and antibonding electrons in molecular orbital theory. A higher bond order means a shorter, stronger bond; zero means no bond."
  },
  {
    "term": "bonding orbital",
    "chapter": 11,
    "section": "11.8",
    "definition": "A molecular orbital lower in energy than the atomic orbitals it came from, because the waves added constructively. Filling it holds the atoms together."
  },
  {
    "term": "electron geometry",
    "chapter": 11,
    "section": "11.3",
    "definition": "The arrangement of all electron groups around the central atom, lone pairs included. It sets the angles; the molecular geometry is what you see of it."
  },
  {
    "term": "electron groups",
    "chapter": 11,
    "section": "11.2",
    "definition": "The things VSEPR counts around a central atom: each lone pair and each bond, with a double or triple bond counting once."
  },
  {
    "term": "hybrid orbitals",
    "chapter": 11,
    "section": "11.7",
    "definition": "Orbitals made by mixing an atom's own s, p and d orbitals, to give the number and directions the observed shape needs. sp³ is four, pointing tetrahedrally."
  },
  {
    "term": "hybridization",
    "chapter": 11,
    "section": "11.7",
    "definition": "The mixing of atomic orbitals on one atom into an equal number of equivalent hybrids. Two electron groups sp, three sp², four sp³."
  },
  {
    "term": "linear geometry",
    "chapter": 11,
    "section": "11.2",
    "definition": "Atoms in a straight line, 180°. Two electron groups with no lone pairs, as in CO₂."
  },
  {
    "term": "molecular geometry",
    "chapter": 11,
    "section": "11.3",
    "definition": "The shape made by the atoms alone — the electron geometry with the lone pairs left invisible but still pushing."
  },
  {
    "term": "molecular orbital theory",
    "chapter": 11,
    "section": "11.8",
    "definition": "Bonding treated by combining atomic orbitals into orbitals spread over the whole molecule. Harder than Lewis, but it explains magnetism and bond order correctly."
  },
  {
    "term": "nonbonding orbital",
    "chapter": 11,
    "section": "11.8",
    "definition": "A molecular orbital essentially unchanged from the atomic orbital it came from, neither helping nor hindering the bond."
  },
  {
    "term": "octahedral geometry",
    "chapter": 11,
    "section": "11.2",
    "definition": "Six electron groups at 90°, like two square pyramids base to base. SF₆."
  },
  {
    "term": "pi (π) bond",
    "chapter": 11,
    "section": "11.7",
    "definition": "A bond from p orbitals overlapping side by side, above and below the bond axis. Weaker than a sigma bond, and it is what stops rotation."
  },
  {
    "term": "seesaw geometry",
    "chapter": 11,
    "section": "11.3",
    "definition": "Five electron groups with one lone pair, which takes an equatorial position, leaving the four atoms in a seesaw."
  },
  {
    "term": "sigma (σ) bond",
    "chapter": 11,
    "section": "11.7",
    "definition": "A bond from orbitals overlapping end to end, along the line between the nuclei. Every single bond is one."
  },
  {
    "term": "square planar geometry",
    "chapter": 11,
    "section": "11.3",
    "definition": "Six electron groups with two lone pairs opposite one another, leaving four atoms in a square at 90°."
  },
  {
    "term": "square pyramidal geometry",
    "chapter": 11,
    "section": "11.3",
    "definition": "Six electron groups with one lone pair, leaving five atoms in a pyramid on a square base."
  },
  {
    "term": "T-shaped geometry",
    "chapter": 11,
    "section": "11.3",
    "definition": "Five electron groups with two lone pairs equatorial, leaving three atoms in a T."
  },
  {
    "term": "tetrahedral geometry",
    "chapter": 11,
    "section": "11.2",
    "definition": "Four electron groups at 109.5°, pointing to the corners of a tetrahedron. Methane, and most of organic chemistry."
  },
  {
    "term": "trigonal bipyramidal geometry",
    "chapter": 11,
    "section": "11.2",
    "definition": "Five electron groups: three equatorial at 120° and two axial at 90°. The two positions are not equivalent, which matters when lone pairs choose."
  },
  {
    "term": "trigonal planar geometry",
    "chapter": 11,
    "section": "11.2",
    "definition": "Three electron groups flat at 120°. BF₃, and the carbon of a carbonyl."
  },
  {
    "term": "trigonal pyramidal geometry",
    "chapter": 11,
    "section": "11.3",
    "definition": "Four electron groups with one lone pair, so three atoms sit in a shallow pyramid at about 107°. Ammonia."
  },
  {
    "term": "valence bond theory",
    "chapter": 11,
    "section": "11.6",
    "definition": "Bonding treated as the overlap of hybridised atomic orbitals on each atom. It explains shape and rotation while staying close to Lewis structures."
  },
  {
    "term": "valence shell electron pair repulsion (VSEPR) theory",
    "chapter": 11,
    "section": "11.2",
    "definition": "Electron groups arrange themselves as far apart as possible, so counting them gives the shape. Lone pairs repel hardest, which closes the angles slightly."
  },
  {
    "term": "boiling point",
    "chapter": 12,
    "section": "12.5",
    "definition": "The temperature at which a liquid's vapour pressure equals the pressure above it, so bubbles can form throughout."
  },
  {
    "term": "capillary action",
    "chapter": 12,
    "section": "12.4",
    "definition": "A liquid climbing a narrow tube on its own, when its attraction to the walls beats its attraction to itself."
  },
  {
    "term": "Clausius–Clapeyron equation",
    "chapter": 12,
    "section": "12.5",
    "definition": "The relation between vapour pressure and temperature, ln P = −ΔHvap/RT + C. A plot of ln P against 1/T gives ΔHvap from the slope."
  },
  {
    "term": "condensation",
    "chapter": 12,
    "section": "12.5",
    "definition": "Gas becoming liquid. Exothermic — it gives back the heat vaporisation took."
  },
  {
    "term": "critical point",
    "chapter": 12,
    "section": "12.8",
    "definition": "The end of the liquid–gas line, where the two become indistinguishable. Past it no amount of pressure will liquefy the gas."
  },
  {
    "term": "critical pressure",
    "chapter": 12,
    "section": "12.5",
    "definition": "The pressure at the critical point — the pressure needed to liquefy a gas at its critical temperature."
  },
  {
    "term": "critical temperature",
    "chapter": 12,
    "section": "12.5",
    "definition": "The temperature above which a substance cannot be liquefied however hard it is squeezed."
  },
  {
    "term": "deposition",
    "chapter": 12,
    "section": "12.6",
    "definition": "Gas becoming solid directly, with no liquid in between. Frost."
  },
  {
    "term": "dipole–dipole force",
    "chapter": 12,
    "section": "12.3",
    "definition": "Attraction between polar molecules, positive end to negative end. Stronger than dispersion for molecules of similar size, so polar substances boil higher."
  },
  {
    "term": "dispersion force",
    "chapter": 12,
    "section": "12.3",
    "definition": "The attraction present between all molecules, from momentary uneven electron distributions. Weak each time, but it grows with size, so it can dominate in big molecules."
  },
  {
    "term": "dynamic equilibrium",
    "chapter": 12,
    "section": "12.5",
    "definition": "Two opposite processes running at equal rates, so nothing appears to change while both continue. Evaporation and condensation in a closed bottle."
  },
  {
    "term": "freezing",
    "chapter": 12,
    "section": "12.6",
    "definition": "Liquid becoming solid, releasing the heat of fusion."
  },
  {
    "term": "heat (or enthalpy) of sublimation (∆Hsub)",
    "chapter": 12,
    "section": "12.6",
    "definition": "The heat to turn one mole of solid straight to gas. It equals ΔHfus + ΔHvap, as Hess's law requires."
  },
  {
    "term": "heat (or enthalpy) of vaporization (∆Hvap)",
    "chapter": 12,
    "section": "12.5",
    "definition": "The heat to turn one mole of liquid into gas at its boiling point. Large, because every intermolecular attraction has to be broken."
  },
  {
    "term": "heat of fusion (∆Hfus)",
    "chapter": 12,
    "section": "12.6",
    "definition": "The heat to melt one mole of solid. Smaller than vaporisation, because melting only loosens the particles rather than separating them."
  },
  {
    "term": "hydrogen bond",
    "chapter": 12,
    "section": "12.3",
    "definition": "The unusually strong attraction between an H bonded to N, O or F and a lone pair on another N, O or F. Why water boils at 100 °C instead of about −80."
  },
  {
    "term": "hydrogen bonding",
    "chapter": 12,
    "section": "12.3",
    "definition": "Hydrogen bonds acting as the dominant force in a substance, which shows up as high boiling points, high surface tension and unusual solubility."
  },
  {
    "term": "ion–dipole force",
    "chapter": 12,
    "section": "12.3",
    "definition": "Attraction between an ion and a polar molecule. The strongest of these forces, and what drives salts to dissolve in water."
  },
  {
    "term": "melting (fusion)",
    "chapter": 12,
    "section": "12.6",
    "definition": "Solid becoming liquid, absorbing the heat of fusion."
  },
  {
    "term": "melting point",
    "chapter": 12,
    "section": "12.6",
    "definition": "The temperature at which solid and liquid are in equilibrium. Higher when the intermolecular forces are stronger."
  },
  {
    "term": "miscibility",
    "chapter": 12,
    "section": "12.3",
    "definition": "How well two liquids mix. Like dissolves like: polar with polar, nonpolar with nonpolar."
  },
  {
    "term": "nonvolatile",
    "chapter": 12,
    "section": "12.5",
    "definition": "Having a very low vapour pressure, so it hardly evaporates."
  },
  {
    "term": "normal boiling point",
    "chapter": 12,
    "section": "12.5",
    "definition": "The boiling point at exactly 1 atm — the number that gets tabulated, since the real one changes with altitude."
  },
  {
    "term": "permanent dipole",
    "chapter": 12,
    "section": "12.3",
    "definition": "A separation of charge built into a polar molecule, as opposed to the fleeting one behind dispersion forces."
  },
  {
    "term": "phase diagram",
    "chapter": 12,
    "section": "12.8",
    "definition": "A map of pressure against temperature showing which phase is stable where, with lines for the equilibria and the triple and critical points marked."
  },
  {
    "term": "sublimation",
    "chapter": 12,
    "section": "12.6",
    "definition": "Solid becoming gas directly, with no liquid. Dry ice."
  },
  {
    "term": "surface tension",
    "chapter": 12,
    "section": "12.4",
    "definition": "The energy cost of making more surface, which is why a liquid pulls itself into beads. Strong forces mean high tension; water's is high."
  },
  {
    "term": "triple point",
    "chapter": 12,
    "section": "12.8",
    "definition": "The one pressure and temperature where solid, liquid and gas are all in equilibrium together."
  },
  {
    "term": "vaporization",
    "chapter": 12,
    "section": "12.5",
    "definition": "Liquid becoming gas, absorbing the heat of vaporisation."
  },
  {
    "term": "viscosity",
    "chapter": 12,
    "section": "12.4",
    "definition": "Resistance to flow. It rises with stronger intermolecular forces and longer molecules, and falls as things warm up."
  },
  {
    "term": "atomic solids",
    "chapter": 13,
    "section": "13.4",
    "definition": "Solids whose lattice points are single atoms, held by metallic bonds, covalent networks, or only dispersion forces in the noble gases."
  },
  {
    "term": "band gap",
    "chapter": 13,
    "section": "13.8",
    "definition": "The energy gap between the filled valence band and the empty conduction band. Big gap, insulator; small gap, semiconductor; none, metal."
  },
  {
    "term": "band theory",
    "chapter": 13,
    "section": "13.8",
    "definition": "Molecular orbital theory applied to a whole crystal, where so many orbitals combine that the levels merge into continuous bands."
  },
  {
    "term": "body-centered cubic",
    "chapter": 13,
    "section": "13.3",
    "definition": "A unit cell with atoms at the eight corners and one in the middle. Two atoms per cell, 68 % packing."
  },
  {
    "term": "borosilicate glass (Pyrex®)",
    "chapter": 13,
    "section": "13.7",
    "definition": "Glass with boron oxide added, so it expands little when heated and survives a flame."
  },
  {
    "term": "ceramics",
    "chapter": 13,
    "section": "13.7",
    "definition": "Hard, brittle, heat-resistant materials made from inorganic nonmetals, usually silicates, fired into shape."
  },
  {
    "term": "clay",
    "chapter": 13,
    "section": "13.7",
    "definition": "A fine-grained sheet silicate that holds water between its layers, which is what makes it plastic when wet and hard when fired."
  },
  {
    "term": "concrete",
    "chapter": 13,
    "section": "13.7",
    "definition": "Cement mixed with sand and gravel, which sets by hydration reactions rather than by drying."
  },
  {
    "term": "condensation polymer",
    "chapter": 13,
    "section": "13.9",
    "definition": "A polymer formed by monomers joining with a small molecule, usually water, split out at each link. Nylon, polyester."
  },
  {
    "term": "conduction band",
    "chapter": 13,
    "section": "13.8",
    "definition": "The band of empty orbitals just above the valence band. Electrons reaching it are free to move, and the solid conducts."
  },
  {
    "term": "coordination number (in a crystal structure)",
    "chapter": 13,
    "section": "13.3",
    "definition": "How many nearest neighbours an atom touches in a lattice: 6 for simple cubic, 8 for body-centred, 12 for either closest packing."
  },
  {
    "term": "crystalline lattice",
    "chapter": 13,
    "section": "13.3",
    "definition": "The repeating three-dimensional pattern of particle positions in a crystal."
  },
  {
    "term": "cubic closest packing",
    "chapter": 13,
    "section": "13.3",
    "definition": "Closest packing with the layers in an ABCABC sequence, whose unit cell is face-centred cubic. 74 % packing."
  },
  {
    "term": "diamond",
    "chapter": 13,
    "section": "13.6",
    "definition": "Carbon in a network of sp³ atoms, every one bonded tetrahedrally to four others. The hardest natural substance, and an insulator."
  },
  {
    "term": "dimer",
    "chapter": 13,
    "section": "13.9",
    "definition": "Two monomers joined — the first step of polymerisation."
  },
  {
    "term": "diode",
    "chapter": 13,
    "section": "13.8",
    "definition": "A p–n junction, which lets current pass one way and not the other."
  },
  {
    "term": "face-centered cubic",
    "chapter": 13,
    "section": "13.3",
    "definition": "A unit cell with atoms at the corners and at the centre of each face. Four atoms per cell, 74 % packing."
  },
  {
    "term": "fullerenes",
    "chapter": 13,
    "section": "13.6",
    "definition": "Carbon in closed cages of rings, such as the 60-atom buckyball."
  },
  {
    "term": "glass",
    "chapter": 13,
    "section": "13.7",
    "definition": "An amorphous solid — melted and cooled too fast to crystallise, so it has no long-range order and softens over a range instead of melting sharply."
  },
  {
    "term": "graphene",
    "chapter": 13,
    "section": "13.1",
    "definition": "A single sheet of graphite, one atom thick. Exceptionally strong, and conducts along the sheet."
  },
  {
    "term": "graphite",
    "chapter": 13,
    "section": "13.6",
    "definition": "Carbon in flat sheets of sp² hexagons, with only dispersion forces between the sheets. Soft and slippery because the sheets slide, and conducting because of the delocalised electrons."
  },
  {
    "term": "hexagonal closest packing",
    "chapter": 13,
    "section": "13.3",
    "definition": "Closest packing with the layers in an ABAB sequence. Also 74 % packing, 12 neighbours."
  },
  {
    "term": "ionic solids",
    "chapter": 13,
    "section": "13.4",
    "definition": "Solids of cations and anions in a lattice held by electrostatic attraction. Hard, brittle, high melting, and conducting only once melted or dissolved."
  },
  {
    "term": "leaded glass",
    "chapter": 13,
    "section": "13.7",
    "definition": "Glass with lead oxide added, which raises the refractive index and gives crystal its sparkle and weight."
  },
  {
    "term": "metallic atomic solids",
    "chapter": 13,
    "section": "13.4",
    "definition": "Metals: cations in a sea of delocalised electrons, which conduct, reflect light and allow the lattice to deform without breaking."
  },
  {
    "term": "molecular solids",
    "chapter": 13,
    "section": "13.4",
    "definition": "Solids of whole molecules held by intermolecular forces only. Soft, low melting, nonconducting. Ice, sugar."
  },
  {
    "term": "monomer",
    "chapter": 13,
    "section": "13.9",
    "definition": "The small repeating unit a polymer is built from."
  },
  {
    "term": "n-type semiconductor",
    "chapter": 13,
    "section": "13.8",
    "definition": "A semiconductor doped with an element having more valence electrons, so the extra electrons carry the current."
  },
  {
    "term": "nanotubes",
    "chapter": 13,
    "section": "13.6",
    "definition": "Carbon rolled into a cylinder one atom thick — very strong, and conducting along its length."
  },
  {
    "term": "network covalent atomic solids",
    "chapter": 13,
    "section": "13.4",
    "definition": "Solids that are one continuous covalent network, so melting means breaking real bonds. Very high melting: diamond, quartz."
  },
  {
    "term": "nonbonding atomic solids",
    "chapter": 13,
    "section": "13.4",
    "definition": "Solids of single atoms held only by dispersion forces — the frozen noble gases, which melt at extremely low temperatures."
  },
  {
    "term": "p-type semiconductor",
    "chapter": 13,
    "section": "13.8",
    "definition": "A semiconductor doped with an element having fewer valence electrons, leaving holes that act as positive carriers."
  },
  {
    "term": "p–n junctions",
    "chapter": 13,
    "section": "13.8",
    "definition": "The boundary between p-type and n-type material, which passes current in one direction only. The basis of every semiconductor device."
  },
  {
    "term": "packing efficiency",
    "chapter": 13,
    "section": "13.3",
    "definition": "The fraction of a unit cell's volume actually filled by the spheres: 52 % simple cubic, 68 % body-centred, 74 % closest packed."
  },
  {
    "term": "polymer",
    "chapter": 13,
    "section": "13.9",
    "definition": "A long molecule built by linking many monomers. Plastics, proteins, DNA, cellulose."
  },
  {
    "term": "polymorphs",
    "chapter": 13,
    "section": "13.4",
    "definition": "Different crystal forms of the same substance, with different properties. Diamond and graphite."
  },
  {
    "term": "Portland cement",
    "chapter": 13,
    "section": "13.7",
    "definition": "The usual cement, a fired mixture of limestone and clay that hardens by reacting with water."
  },
  {
    "term": "quartz",
    "chapter": 13,
    "section": "13.6",
    "definition": "Crystalline SiO₂ — a covalent network of silicon each bonded to four oxygens. Hard, high melting, and an insulator."
  },
  {
    "term": "silica",
    "chapter": 13,
    "section": "13.6",
    "definition": "Silicon dioxide, SiO₂, the main component of sand, quartz and glass."
  },
  {
    "term": "silicates",
    "chapter": 13,
    "section": "13.6",
    "definition": "The enormous family of minerals built from SiO₄ tetrahedra sharing oxygens, which make up most of the Earth's crust."
  },
  {
    "term": "simple cubic",
    "chapter": 13,
    "section": "13.3",
    "definition": "A unit cell with atoms only at the eight corners. One atom per cell, 52 % packing, and rare because it wastes space."
  },
  {
    "term": "soda-lime glass",
    "chapter": 13,
    "section": "13.7",
    "definition": "Ordinary window and bottle glass: silica with sodium and calcium oxides added to lower the melting point."
  },
  {
    "term": "unit cell",
    "chapter": 13,
    "section": "13.3",
    "definition": "The smallest repeating box that builds the whole crystal when stacked. Counting its atoms gives the formula and the density."
  },
  {
    "term": "valence band",
    "chapter": 13,
    "section": "13.8",
    "definition": "The highest band of filled orbitals in a solid. Electrons in it are tied to their atoms and do not conduct."
  },
  {
    "term": "vitreous (or fused) silica",
    "chapter": 13,
    "section": "13.7",
    "definition": "Pure silica melted and cooled into glass. It expands almost nothing on heating and passes ultraviolet."
  },
  {
    "term": "X-ray crystallography",
    "chapter": 13,
    "section": "13.2",
    "definition": "Working out where every atom in a crystal sits from the pattern of X-rays it diffracts."
  },
  {
    "term": "X-ray diffraction",
    "chapter": 13,
    "section": "13.2",
    "definition": "X-rays scattering off the planes of a crystal and interfering, which gives sharp spots at angles set by the spacing (nλ = 2d sin θ)."
  },
  {
    "term": "boiling point elevation",
    "chapter": 14,
    "section": "14.6",
    "definition": "A nonvolatile solute raises a solvent's boiling point: ΔTb = m·Kb·i. Colligative, so it depends on how many particles, not which."
  },
  {
    "term": "colligative property",
    "chapter": 14,
    "section": "14.6",
    "definition": "A property depending only on the number of solute particles, not their identity: boiling point elevation, freezing point depression, osmotic pressure, vapour pressure lowering."
  },
  {
    "term": "colloidal dispersion (colloid)",
    "chapter": 14,
    "section": "14.8",
    "definition": "A mixture whose particles are too big to be a true solution but too small to settle. Milk, fog, jelly."
  },
  {
    "term": "enthalpy of solution (∆Hsoln)",
    "chapter": 14,
    "section": "14.3",
    "definition": "The heat change on dissolving: the energy to pull the solute apart plus the energy released as the solvent surrounds it. Its sign says whether the solution warms or cools."
  },
  {
    "term": "entropy",
    "chapter": 14,
    "section": "14.2",
    "definition": "A measure of how spread out energy and matter are — loosely, of disorder. Its increase is why things dissolve even when the heat change is unfavourable."
  },
  {
    "term": "freezing point depression",
    "chapter": 14,
    "section": "14.6",
    "definition": "A solute lowers a solvent's freezing point: ΔTf = m·Kf·i. Salt on icy roads, antifreeze in an engine."
  },
  {
    "term": "heat of hydration (∆Hhydration)",
    "chapter": 14,
    "section": "14.3",
    "definition": "The heat released as gaseous ions are surrounded by water. Always negative, and large for small, highly charged ions."
  },
  {
    "term": "Henry’s law",
    "chapter": 14,
    "section": "14.4",
    "definition": "The amount of gas dissolved is proportional to its partial pressure above the liquid: S = kP. Why a bottle fizzes when it is opened."
  },
  {
    "term": "ideal solution",
    "chapter": 14,
    "section": "14.6",
    "definition": "A solution that follows Raoult's law at all concentrations, because solute–solvent attractions match the ones they replaced."
  },
  {
    "term": "miscible",
    "chapter": 14,
    "section": "14.2",
    "definition": "Mixing in any proportion without separating. Water and ethanol."
  },
  {
    "term": "molality (m)",
    "chapter": 14,
    "section": "14.5",
    "definition": "Moles of solute per kilogram of solvent. Used for colligative properties because, unlike molarity, it does not change with temperature."
  },
  {
    "term": "mole fraction (χsolute)",
    "chapter": 14,
    "section": "14.5",
    "definition": "Moles of solute over total moles of everything present. The concentration unit Raoult's law needs."
  },
  {
    "term": "mole percent",
    "chapter": 14,
    "section": "14.5",
    "definition": "The mole fraction as a percentage."
  },
  {
    "term": "osmosis",
    "chapter": 14,
    "section": "14.6",
    "definition": "Solvent moving through a semipermeable membrane from the dilute side to the concentrated side."
  },
  {
    "term": "osmotic pressure",
    "chapter": 14,
    "section": "14.6",
    "definition": "The pressure needed to stop osmosis: Π = MRT·i. Even dilute solutions give surprisingly large values."
  },
  {
    "term": "parts by mass",
    "chapter": 14,
    "section": "14.5",
    "definition": "A concentration given as mass of solute over total mass, times a power of ten — percent, ppm or ppb."
  },
  {
    "term": "parts by volume",
    "chapter": 14,
    "section": "14.5",
    "definition": "A concentration given as volume of solute over total volume, times a power of ten."
  },
  {
    "term": "parts per billion (ppb)",
    "chapter": 14,
    "section": "14.5",
    "definition": "Mass of solute per 10⁹ of solution. Used for traces, like contaminants in water."
  },
  {
    "term": "parts per million (ppm)",
    "chapter": 14,
    "section": "14.5",
    "definition": "Mass of solute per 10⁶ of solution — one milligram per kilogram."
  },
  {
    "term": "percent by mass",
    "chapter": 14,
    "section": "14.5",
    "definition": "Mass of solute over total mass, times 100 %."
  },
  {
    "term": "Raoult’s law",
    "chapter": 14,
    "section": "14.6",
    "definition": "The vapour pressure over a solution is the pure solvent's times its mole fraction: P = χsolvent·P°. Adding solute lowers the vapour pressure."
  },
  {
    "term": "recrystallization",
    "chapter": 14,
    "section": "14.4",
    "definition": "Purifying a solid by dissolving it hot and cooling slowly, so the pure compound crystallises and the impurities stay in solution."
  },
  {
    "term": "saturated solution",
    "chapter": 14,
    "section": "14.4",
    "definition": "A solution holding as much solute as it can at that temperature, with dissolving and crystallising in equilibrium."
  },
  {
    "term": "semipermeable membrane",
    "chapter": 14,
    "section": "14.6",
    "definition": "A barrier passing solvent but not solute. What makes osmosis possible."
  },
  {
    "term": "solubility",
    "chapter": 14,
    "section": "14.2",
    "definition": "How much of a substance dissolves in a given amount of solvent at a given temperature."
  },
  {
    "term": "supersaturated solution",
    "chapter": 14,
    "section": "14.4",
    "definition": "A solution holding more than its saturation amount, which is unstable: a seed crystal or a scratch makes the excess crash out."
  },
  {
    "term": "Tyndall effect",
    "chapter": 14,
    "section": "14.8",
    "definition": "Light scattered by colloidal particles, making the beam visible. A headlight in fog."
  },
  {
    "term": "unsaturated solution",
    "chapter": 14,
    "section": "14.4",
    "definition": "A solution that could still dissolve more solute."
  },
  {
    "term": "van’t Hoff factor (i)",
    "chapter": 14,
    "section": "14.7",
    "definition": "How many particles one formula unit gives in solution: 1 for sugar, 2 for NaCl, 3 for CaCl₂. It multiplies every colligative effect."
  },
  {
    "term": "vapor pressure lowering (∆P)",
    "chapter": 14,
    "section": "14.6",
    "definition": "The drop in a solvent's vapour pressure when a nonvolatile solute is added, which is what causes the boiling point to rise."
  },
  {
    "term": "bimolecular",
    "chapter": 15,
    "section": "15.6",
    "definition": "An elementary step with two particles colliding. The commonest kind."
  },
  {
    "term": "catalyst",
    "chapter": 15,
    "section": "15.7",
    "definition": "Something that speeds a reaction by offering a path with a lower activation energy, and is not consumed. It does not change ΔH or the equilibrium position."
  },
  {
    "term": "collision frequency",
    "chapter": 15,
    "section": "15.5",
    "definition": "How often the reacting particles collide per second. Enormous, which is why only a tiny fraction of collisions can be succeeding."
  },
  {
    "term": "collision model",
    "chapter": 15,
    "section": "15.5",
    "definition": "The picture behind rate laws: particles must collide, hard enough and lined up correctly, for a reaction to happen."
  },
  {
    "term": "elementary step",
    "chapter": 15,
    "section": "15.6",
    "definition": "A single molecular event in a mechanism, whose rate law can be read straight off its own equation — unlike the overall reaction."
  },
  {
    "term": "enzyme",
    "chapter": 15,
    "section": "15.7",
    "definition": "A biological catalyst, almost always a protein, which binds its substrate in an active site and is extraordinarily specific and fast."
  },
  {
    "term": "exponential factor",
    "chapter": 15,
    "section": "15.5",
    "definition": "The e^(−Ea/RT) part of the Arrhenius equation: the fraction of collisions with enough energy. It is why rate climbs so steeply with temperature."
  },
  {
    "term": "frequency factor",
    "chapter": 15,
    "section": "15.5",
    "definition": "A in the Arrhenius equation — how often collisions happen with the right orientation, before energy is considered."
  },
  {
    "term": "half-life (t½)",
    "chapter": 15,
    "section": "15.4",
    "definition": "The time for half the reactant to be used up. Constant for a first-order reaction, regardless of how much you started with."
  },
  {
    "term": "heterogeneous catalysis",
    "chapter": 15,
    "section": "15.7",
    "definition": "Catalysis where the catalyst is a different phase from the reactants, usually a solid surface. A car's catalytic converter."
  },
  {
    "term": "homogeneous catalysis",
    "chapter": 15,
    "section": "15.7",
    "definition": "Catalysis where the catalyst is in the same phase as the reactants, mixed right in."
  },
  {
    "term": "hydrogenation",
    "chapter": 15,
    "section": "15.7",
    "definition": "Adding H₂ across a double bond, over a metal catalyst. How liquid oils are made solid."
  },
  {
    "term": "integrated rate law",
    "chapter": 15,
    "section": "15.4",
    "definition": "The form of a rate law giving concentration against time rather than rate against concentration. Which plot comes out straight tells you the order."
  },
  {
    "term": "molecularity",
    "chapter": 15,
    "section": "15.6",
    "definition": "How many particles take part in an elementary step: one, two or, rarely, three."
  },
  {
    "term": "orientation factor",
    "chapter": 15,
    "section": "15.5",
    "definition": "The part of the frequency factor accounting for collisions only working when the particles are lined up the right way."
  },
  {
    "term": "overall order",
    "chapter": 15,
    "section": "15.3",
    "definition": "The sum of the exponents in the rate law. It must be found by experiment; it cannot be read off the balanced equation."
  },
  {
    "term": "rate constant (k)",
    "chapter": 15,
    "section": "15.3",
    "definition": "The proportionality constant in a rate law. It depends on temperature and on the catalyst, but not on concentration."
  },
  {
    "term": "rate law",
    "chapter": 15,
    "section": "15.3",
    "definition": "The equation relating rate to reactant concentrations, rate = k[A]^m[B]^n. The exponents come from experiment."
  },
  {
    "term": "rate-determining step",
    "chapter": 15,
    "section": "15.6",
    "definition": "The slowest elementary step, which sets the overall rate. The rate law of the whole reaction is essentially the rate law of this step."
  },
  {
    "term": "reaction intermediate",
    "chapter": 15,
    "section": "15.6",
    "definition": "A species made in one step and used up in a later one, so it appears in the mechanism but not in the overall equation."
  },
  {
    "term": "reaction mechanism",
    "chapter": 15,
    "section": "15.6",
    "definition": "The actual sequence of elementary steps a reaction goes through. A proposed mechanism must add up to the overall equation and predict the observed rate law."
  },
  {
    "term": "reaction order (n)",
    "chapter": 15,
    "section": "15.3",
    "definition": "The exponent on one reactant in the rate law, saying how sensitive the rate is to that concentration. Zero order means no effect at all."
  },
  {
    "term": "substrate",
    "chapter": 15,
    "section": "15.7",
    "definition": "The molecule an enzyme acts on, which fits into its active site."
  },
  {
    "term": "termolecular",
    "chapter": 15,
    "section": "15.6",
    "definition": "An elementary step needing three particles to collide at once. Very rare, because the odds are so poor."
  },
  {
    "term": "unimolecular",
    "chapter": 15,
    "section": "15.6",
    "definition": "An elementary step involving a single particle falling apart or rearranging on its own."
  },
  {
    "term": "equilibrium constant (K)",
    "chapter": 16,
    "section": "16.3",
    "definition": "Products over reactants at equilibrium, each raised to its coefficient. Large K means the products are favoured; it depends only on temperature."
  },
  {
    "term": "law of mass action",
    "chapter": 16,
    "section": "16.3",
    "definition": "The rule for writing K from a balanced equation: multiply the product concentrations, divide by the reactant concentrations, each to the power of its coefficient, leaving out pure solids and liquids."
  },
  {
    "term": "Le Châtelier’s principle",
    "chapter": 16,
    "section": "16.9",
    "definition": "Disturb a system at equilibrium and it shifts in the direction that undoes the disturbance. Add a reactant and it moves right; heat an exothermic reaction and it moves left."
  },
  {
    "term": "reaction quotient (Qc)",
    "chapter": 16,
    "section": "16.7",
    "definition": "The same expression as K, but with whatever the concentrations are right now. Q < K moves forward, Q > K moves back, Q = K is equilibrium."
  },
  {
    "term": "reversible",
    "chapter": 16,
    "section": "16.2",
    "definition": "Able to run in both directions, so the reaction settles at an equilibrium instead of going to completion."
  },
  {
    "term": "autoionization",
    "chapter": 17,
    "section": "17.5",
    "definition": "Water reacting with itself to give tiny amounts of H₃O⁺ and OH⁻. It is why pure water has a pH at all."
  },
  {
    "term": "base ionization constant (Kb)",
    "chapter": 17,
    "section": "17.7",
    "definition": "The equilibrium constant for a weak base taking a proton from water. Bigger Kb, stronger base, and Ka·Kb = Kw for a conjugate pair."
  },
  {
    "term": "basic solution",
    "chapter": 17,
    "section": "17.5",
    "definition": "A solution with more OH⁻ than H₃O⁺ — pH above 7 at 25 °C."
  },
  {
    "term": "Brønsted–Lowry definitions (of acids and bases)",
    "chapter": 17,
    "section": "17.3",
    "definition": "An acid donates a proton, a base accepts one. Broader than the older definition, and it makes every reaction a competition for H⁺."
  },
  {
    "term": "carboxylic acid",
    "chapter": 17,
    "section": "17.2",
    "definition": "An organic acid with a –COOH group: acetic acid, citric acid. All weak."
  },
  {
    "term": "conjugate acid",
    "chapter": 17,
    "section": "17.3",
    "definition": "What a base becomes once it has accepted a proton. NH₃ gives NH₄⁺."
  },
  {
    "term": "conjugate acid–base pair",
    "chapter": 17,
    "section": "17.3",
    "definition": "Two species differing by exactly one proton: HCl/Cl⁻, NH₄⁺/NH₃. The stronger the acid, the weaker its conjugate base."
  },
  {
    "term": "conjugate base",
    "chapter": 17,
    "section": "17.3",
    "definition": "What an acid becomes once it has given up a proton. HF gives F⁻."
  },
  {
    "term": "ion product constant for water (Kw)",
    "chapter": 17,
    "section": "17.5",
    "definition": "[H₃O⁺][OH⁻] = 1.0 × 10⁻¹⁴ at 25 °C. Knowing one concentration always gives the other."
  },
  {
    "term": "Lewis acid",
    "chapter": 17,
    "section": "17.11",
    "definition": "An electron-pair acceptor. Broader again than Brønsted–Lowry: it covers species with no proton to give, such as BF₃ and metal cations."
  },
  {
    "term": "Lewis base",
    "chapter": 17,
    "section": "17.11",
    "definition": "An electron-pair donor — something with a lone pair to offer."
  },
  {
    "term": "monoprotic acid",
    "chapter": 17,
    "section": "17.4",
    "definition": "An acid with one ionisable hydrogen: HCl, HNO₃, acetic acid."
  },
  {
    "term": "neutral",
    "chapter": 17,
    "section": "17.5",
    "definition": "Having equal H₃O⁺ and OH⁻ — pH 7 at 25 °C."
  },
  {
    "term": "percent ionization",
    "chapter": 17,
    "section": "17.6",
    "definition": "The fraction of a weak acid that has actually ionised, times 100 %. It rises as the solution gets more dilute."
  },
  {
    "term": "pH",
    "chapter": 17,
    "section": "17.5",
    "definition": "−log[H₃O⁺]. Each unit is a factor of ten, so pH 3 is a hundred times more acidic than pH 5."
  },
  {
    "term": "strong base",
    "chapter": 17,
    "section": "17.7",
    "definition": "A base that dissociates completely: the group 1 hydroxides, plus Ca(OH)₂, Sr(OH)₂ and Ba(OH)₂."
  },
  {
    "term": "triprotic acid",
    "chapter": 17,
    "section": "17.4",
    "definition": "An acid with three ionisable hydrogens, such as H₃PO₄."
  },
  {
    "term": "weak base",
    "chapter": 17,
    "section": "17.7",
    "definition": "A base that only partly accepts protons in water, leaving an equilibrium. Ammonia, the amines."
  },
  {
    "term": "buffer",
    "chapter": 18,
    "section": "18.2",
    "definition": "A solution of a weak acid with its conjugate base, which resists pH change because one component mops up added acid and the other added base."
  },
  {
    "term": "buffer capacity",
    "chapter": 18,
    "section": "18.3",
    "definition": "How much acid or base a buffer can absorb before its pH moves much. It depends on how concentrated the pair is, not on the ratio."
  },
  {
    "term": "common ion effect",
    "chapter": 18,
    "section": "18.2",
    "definition": "Adding an ion that is already in an equilibrium pushes it back, so a weak acid ionises less and a salt dissolves less."
  },
  {
    "term": "complex ion",
    "chapter": 18,
    "section": "18.8",
    "definition": "A central metal ion with ligands bonded to it, carrying an overall charge: Ag(NH₃)₂⁺, Cu(NH₃)₄²⁺."
  },
  {
    "term": "endpoint",
    "chapter": 18,
    "section": "18.4",
    "definition": "Where the indicator actually changes colour, which is what you observe. Chosen to be as close as possible to the real equivalence point."
  },
  {
    "term": "formation constant (Kf)",
    "chapter": 18,
    "section": "18.8",
    "definition": "The equilibrium constant for forming a complex ion. Usually huge, which is why complex formation can dissolve an otherwise insoluble salt."
  },
  {
    "term": "Henderson–Hasselbalch equation",
    "chapter": 18,
    "section": "18.2",
    "definition": "pH = pKa + log([base]/[acid]), the shortcut for a buffer's pH. When the two are equal, pH = pKa."
  },
  {
    "term": "ligand",
    "chapter": 18,
    "section": "18.8",
    "definition": "A Lewis base bonded to a central metal ion in a complex: NH₃, H₂O, CN⁻, Cl⁻."
  },
  {
    "term": "molar solubility",
    "chapter": 18,
    "section": "18.5",
    "definition": "How many moles of a salt dissolve per litre of solution before saturation. It is what Ksp is converted into to compare salts."
  },
  {
    "term": "qualitative analysis",
    "chapter": 18,
    "section": "18.7",
    "definition": "Finding out which ions are present, classically by precipitating them out in groups with a planned sequence of reagents."
  },
  {
    "term": "quantitative analysis",
    "chapter": 18,
    "section": "18.7",
    "definition": "Finding out how much is present, by measurement — a titration, a mass of precipitate."
  },
  {
    "term": "selective precipitation",
    "chapter": 18,
    "section": "18.6",
    "definition": "Separating ions by adding a reagent that precipitates one and leaves the other in solution, because their Ksp values differ enough."
  },
  {
    "term": "solubility product constant (Ksp)",
    "chapter": 18,
    "section": "18.5",
    "definition": "The equilibrium constant for a slightly soluble salt dissolving: the product of its ion concentrations, each to its coefficient. Smaller Ksp, less soluble."
  },
  {
    "term": "free energy of formation (ΔG°f)",
    "chapter": 19,
    "section": "19.8",
    "definition": "The free energy change forming one mole of a substance from its elements in their standard states. Zero for an element in its standard state."
  },
  {
    "term": "Gibbs free energy (G)",
    "chapter": 19,
    "section": "19.6",
    "definition": "G = H − TS, the quantity whose decrease says a process can happen on its own. ΔG negative is spontaneous, positive is not, zero is equilibrium."
  },
  {
    "term": "reversible process",
    "chapter": 19,
    "section": "19.4",
    "definition": "An idealised change made in infinitesimal steps, always at equilibrium, which gets the most work out. Real processes are never quite reversible."
  },
  {
    "term": "second law of thermodynamics",
    "chapter": 19,
    "section": "19.3",
    "definition": "The entropy of the universe always increases. A process can lower the entropy of a system only by raising the surroundings' more."
  },
  {
    "term": "spontaneous process",
    "chapter": 19,
    "section": "19.2",
    "definition": "One that happens by itself once started, with no continuing push. Spontaneous says nothing about fast — diamond turning to graphite is spontaneous and takes forever."
  },
  {
    "term": "standard entropy change for a reaction (∆S°rxn)",
    "chapter": 19,
    "section": "19.7",
    "definition": "Sum of the products' standard molar entropies minus the reactants'. Positive when the reaction makes more gas or more freedom of motion."
  },
  {
    "term": "standard free energy change (∆G°rxn)",
    "chapter": 19,
    "section": "19.8",
    "definition": "ΔH° − TΔS°, or the sum of the products' ΔG°f minus the reactants'. It fixes K, through ΔG° = −RT ln K."
  },
  {
    "term": "standard molar entropy (S°)",
    "chapter": 19,
    "section": "19.7",
    "definition": "The entropy of one mole of a substance in its standard state. Always positive, and bigger for gases than liquids than solids."
  },
  {
    "term": "third law of thermodynamics",
    "chapter": 19,
    "section": "19.7",
    "definition": "A perfect crystal at absolute zero has zero entropy. This is what makes absolute entropies, rather than only changes, measurable."
  },
  {
    "term": "cathode",
    "chapter": 20,
    "section": "20.3",
    "definition": "The electrode where reduction happens. In a voltaic cell it is the positive one."
  },
  {
    "term": "cell potential (cell emf) (Ecell)",
    "chapter": 20,
    "section": "20.3",
    "definition": "The voltage a cell drives current with — the difference in the two half-cells' pull on electrons. Positive means the reaction goes as written."
  },
  {
    "term": "corrosion",
    "chapter": 20,
    "section": "20.9",
    "definition": "Metal being oxidised by its surroundings. Rusting is iron going to hydrated iron(III) oxide, and it needs both oxygen and water."
  },
  {
    "term": "dry-cell battery",
    "chapter": 20,
    "section": "20.7",
    "definition": "A battery using a paste instead of a liquid electrolyte, so it can be carried in any orientation. The ordinary alkaline cell."
  },
  {
    "term": "electrical current",
    "chapter": 20,
    "section": "20.3",
    "definition": "The flow of charge, in amperes — one coulomb per second."
  },
  {
    "term": "electrochemical cell",
    "chapter": 20,
    "section": "20.3",
    "definition": "Any device that connects a redox reaction to an electric circuit, either producing current or being driven by it."
  },
  {
    "term": "electrode",
    "chapter": 20,
    "section": "20.3",
    "definition": "The conducting surface where a half-reaction takes place and electrons enter or leave the circuit."
  },
  {
    "term": "electrolysis",
    "chapter": 20,
    "section": "20.8",
    "definition": "Forcing a nonspontaneous redox reaction by pushing current through. How aluminium is won and how metals are plated."
  },
  {
    "term": "electrolytic cell",
    "chapter": 20,
    "section": "20.3",
    "definition": "A cell in which an outside source drives a reaction that would not happen on its own. Here the cathode is negative."
  },
  {
    "term": "Faraday’s constant (F)",
    "chapter": 20,
    "section": "20.5",
    "definition": "The charge on one mole of electrons, 96 485 C/mol. It converts between moles of electrons and the current-times-time you measure."
  },
  {
    "term": "fuel cell",
    "chapter": 20,
    "section": "20.7",
    "definition": "A cell fed continuously with fuel and oxidant instead of carrying its reactants inside, so it does not run flat. Hydrogen and oxygen giving water."
  },
  {
    "term": "half-cell",
    "chapter": 20,
    "section": "20.3",
    "definition": "One half of a cell: the electrode with its solution, where either the oxidation or the reduction happens."
  },
  {
    "term": "lead–acid storage battery",
    "chapter": 20,
    "section": "20.7",
    "definition": "The car battery: lead and lead dioxide plates in sulfuric acid, rechargeable, with six cells in series for 12 V."
  },
  {
    "term": "lithium ion battery",
    "chapter": 20,
    "section": "20.7",
    "definition": "A rechargeable battery that works by lithium ions moving between electrodes rather than by plating metal out. High energy for its mass, which is why it is in everything."
  },
  {
    "term": "Nernst equation",
    "chapter": 20,
    "section": "20.6",
    "definition": "E = E° − (0.0592/n)·log Q at 25 °C: how a cell's voltage falls as it discharges and Q climbs toward K. At equilibrium E = 0, which is a flat battery."
  },
  {
    "term": "nickel–cadmium (NiCad) battery",
    "chapter": 20,
    "section": "20.7",
    "definition": "An older rechargeable cell with a steady voltage, now largely replaced because cadmium is toxic."
  },
  {
    "term": "nickel–metal hydride (NiMH) battery",
    "chapter": 20,
    "section": "20.7",
    "definition": "A rechargeable cell storing hydrogen in a metal alloy. It replaced NiCad with no cadmium and more capacity."
  },
  {
    "term": "potential difference",
    "chapter": 20,
    "section": "20.3",
    "definition": "The energy per unit charge between two points — what drives the electrons round, measured in volts."
  },
  {
    "term": "salt bridge",
    "chapter": 20,
    "section": "20.3",
    "definition": "The connection letting ions pass between the two half-cells so the charge stays balanced. Without it the cell stops at once."
  },
  {
    "term": "standard cell potential (standard emf) (E°cell)",
    "chapter": 20,
    "section": "20.3",
    "definition": "The cell potential with everything in its standard state: E°cathode − E°anode. It is positive for a spontaneous cell."
  },
  {
    "term": "standard electrode potential",
    "chapter": 20,
    "section": "20.4",
    "definition": "A half-reaction's reduction potential measured against the standard hydrogen electrode. More positive means a stronger pull on electrons."
  },
  {
    "term": "standard hydrogen electrode (SHE)",
    "chapter": 20,
    "section": "20.4",
    "definition": "The agreed zero of the potential scale: H⁺ at 1 M over platinum with H₂ at 1 atm, defined as exactly 0 V."
  },
  {
    "term": "volt",
    "chapter": 20,
    "section": "20.3",
    "definition": "The unit of potential difference, one joule per coulomb."
  },
  {
    "term": "voltaic (galvanic) cell",
    "chapter": 20,
    "section": "20.3",
    "definition": "A cell in which a spontaneous reaction produces current — a battery. Here the anode is negative."
  },
  {
    "term": "beta (β) decay",
    "chapter": 21,
    "section": "21.3",
    "definition": "A nucleus converting a neutron into a proton and firing out an electron. The atomic number goes up by one; the mass number does not change."
  },
  {
    "term": "beta (β) particle",
    "chapter": 21,
    "section": "21.3",
    "definition": "The high-speed electron emitted in beta decay. More penetrating than alpha, less than gamma."
  },
  {
    "term": "biological effectiveness factor (RBE)",
    "chapter": 21,
    "section": "21.11",
    "definition": "The multiplier for how much damage a kind of radiation does per unit of energy. It turns an absorbed dose into a dose in rems."
  },
  {
    "term": "chain reaction",
    "chapter": 21,
    "section": "21.7",
    "definition": "A fission reaction whose own neutrons set off further fissions, so it sustains or runs away by itself."
  },
  {
    "term": "critical mass",
    "chapter": 21,
    "section": "21.7",
    "definition": "The least fissionable material needed for a chain reaction to sustain itself, instead of the neutrons escaping first."
  },
  {
    "term": "cyclotron",
    "chapter": 21,
    "section": "21.10",
    "definition": "A particle accelerator that spirals charged particles outward in a magnetic field, pushing them each turn. Used to make new nuclides."
  },
  {
    "term": "dose",
    "chapter": 21,
    "section": "21.11",
    "definition": "The radiation energy actually absorbed per unit mass of tissue."
  },
  {
    "term": "electron capture",
    "chapter": 21,
    "section": "21.3",
    "definition": "A nucleus pulling in one of its own inner electrons, turning a proton into a neutron. The atomic number drops by one."
  },
  {
    "term": "exposure",
    "chapter": 21,
    "section": "21.11",
    "definition": "How much radiation something was in, as opposed to how much it absorbed."
  },
  {
    "term": "gamma (γ) ray emission",
    "chapter": 21,
    "section": "21.3",
    "definition": "A nucleus shedding excess energy as a high-energy photon. Neither the atomic number nor the mass number changes, and it usually follows another decay."
  },
  {
    "term": "Geiger–Müller counter",
    "chapter": 21,
    "section": "21.5",
    "definition": "A detector in which radiation ionises a gas and triggers a pulse of current — the familiar clicking instrument."
  },
  {
    "term": "ionizing power",
    "chapter": 21,
    "section": "21.3",
    "definition": "How effectively radiation knocks electrons off the matter it passes through. Alpha is the most ionising, which is why it does so much damage once inside."
  },
  {
    "term": "linear accelerator",
    "chapter": 21,
    "section": "21.10",
    "definition": "An accelerator that drives particles down a straight line through a series of electrodes."
  },
  {
    "term": "magic numbers",
    "chapter": 21,
    "section": "21.4",
    "definition": "The proton and neutron counts (2, 8, 20, 28, 50, 82, 126) that give unusually stable nuclei — the nuclear equivalent of a full shell."
  },
  {
    "term": "mass defect",
    "chapter": 21,
    "section": "21.8",
    "definition": "The difference between a nucleus's mass and the sum of its separate nucleons. The missing mass is the binding energy, by E = mc²."
  },
  {
    "term": "nuclear binding energy",
    "chapter": 21,
    "section": "21.8",
    "definition": "The energy holding a nucleus together, which is also the energy needed to take it apart. Highest per nucleon around iron, which is why both fission and fusion release energy."
  },
  {
    "term": "nuclear equation",
    "chapter": 21,
    "section": "21.3",
    "definition": "An equation for a nuclear change, balanced by mass number and atomic number rather than by atoms."
  },
  {
    "term": "nuclear fission",
    "chapter": 21,
    "section": "21.7",
    "definition": "A heavy nucleus splitting into lighter ones, releasing neutrons and a great deal of energy. Uranium-235 in a reactor."
  },
  {
    "term": "nuclear fusion",
    "chapter": 21,
    "section": "21.9",
    "definition": "Light nuclei joining into a heavier one, releasing even more energy per gram. What the sun does, and hard to do on Earth because the nuclei repel."
  },
  {
    "term": "nucleons",
    "chapter": 21,
    "section": "21.4",
    "definition": "The particles in a nucleus — protons and neutrons together."
  },
  {
    "term": "nuclide",
    "chapter": 21,
    "section": "21.3",
    "definition": "A particular nuclear species, fixed by its proton and neutron count. Carbon-12 and carbon-14 are different nuclides."
  },
  {
    "term": "penetrating power",
    "chapter": 21,
    "section": "21.3",
    "definition": "How far radiation gets through matter. Gamma passes through concrete; beta is stopped by metal foil; alpha by paper or skin."
  },
  {
    "term": "phosphorescence",
    "chapter": 21,
    "section": "21.2",
    "definition": "The glow a substance keeps giving off after the light that excited it has stopped."
  },
  {
    "term": "positron",
    "chapter": 21,
    "section": "21.3",
    "definition": "The antiparticle of the electron: the same mass, positive charge. It annihilates on meeting an electron, giving two gamma rays."
  },
  {
    "term": "positron emission",
    "chapter": 21,
    "section": "21.3",
    "definition": "A nucleus turning a proton into a neutron and firing out a positron. The atomic number drops by one, the mass number stays."
  },
  {
    "term": "positron emission tomography (PET)",
    "chapter": 21,
    "section": "21.12",
    "definition": "Medical imaging that locates a positron-emitting tracer from the pairs of gamma rays its annihilations send out back to back."
  },
  {
    "term": "radioactive",
    "chapter": 21,
    "section": "21.1",
    "definition": "Having an unstable nucleus, so it decays and emits radiation."
  },
  {
    "term": "radiocarbon dating",
    "chapter": 21,
    "section": "21.6",
    "definition": "Dating once-living material from its carbon-14, which stops being replenished at death and halves every 5730 years. Good to about 50 000 years."
  },
  {
    "term": "radiometric dating",
    "chapter": 21,
    "section": "21.6",
    "definition": "Dating anything by the ratio of a radioactive nuclide to its decay product, with the half-life as the clock. Uranium–lead for rocks."
  },
  {
    "term": "radiotracer",
    "chapter": 21,
    "section": "21.12",
    "definition": "A radioactive nuclide given in a small amount so its path can be followed — through the body, a pipeline, or a reaction."
  },
  {
    "term": "rem",
    "chapter": 21,
    "section": "21.11",
    "definition": "The old unit of dose adjusted for biological damage: dose in rads times the RBE. A chest X-ray is a few hundredths of a rem."
  },
  {
    "term": "scintillation counter",
    "chapter": 21,
    "section": "21.5",
    "definition": "A detector using a material that flashes when radiation hits it, with the flashes counted by a photomultiplier."
  },
  {
    "term": "strong force",
    "chapter": 21,
    "section": "21.4",
    "definition": "The very short-range attraction between nucleons that holds a nucleus together against the protons' mutual repulsion."
  },
  {
    "term": "thermoluminescent dosimeter",
    "chapter": 21,
    "section": "21.5",
    "definition": "A badge holding a crystal that traps energy from radiation and releases it as light when heated, so the accumulated dose can be read off."
  },
  {
    "term": "transmutation",
    "chapter": 21,
    "section": "21.10",
    "definition": "One element turned into another by a nuclear change, whether by decay or by bombardment."
  }
];

/** Chapter numbers present, in order. */
export const VOCAB_CHAPTERS: number[] = [
  ...new Set(VOCABULARY.map((v) => v.chapter)),
].sort((a, b) => a - b);

/**
 * Case-insensitive substring match on the term, and on the definition too, so
 * that a half-remembered idea finds the word for it: searching "runs out
 * first" finds the limiting reactant. Term matches come first.
 */
export function searchVocabulary(query: string): VocabTerm[] {
  const q = query.trim().toLowerCase();
  if (!q) return VOCABULARY;
  const inTerm = VOCABULARY.filter((v) => v.term.toLowerCase().includes(q));
  const inDefinition = VOCABULARY.filter(
    (v) => !v.term.toLowerCase().includes(q) && v.definition.toLowerCase().includes(q),
  );
  return [...inTerm, ...inDefinition];
}
